import { createFluentIcon } from "@fluentui/react-icons";
import * as React from "react";
import { createFluentIconExtended } from "./utils";

export const OfficePowerPointMono = createFluentIconExtended(
  "OfficePowerPointMono",
  "16px",
  [
    React.createElement("path", {
      d: "M4.5 7.75V6.25H5.25C5.66421 6.25 6 6.58579 6 7C6 7.41421 5.66421 7.75 5.25 7.75H4.5Z",
      key: 0,
    }),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C5.62125 15 3.51964 13.8135 2.25469 12H1.8C1.4 12 1 11.6 1 11.2V4.8C1 4.4 1.4 4 1.8 4H2.25469C3.43024 2.31468 5.32837 1.17084 7.5 1.01758V1H8.5V1.01758C11.9675 1.2623 14.7377 4.03251 14.9824 7.5H15V8.5H14.9824C14.726 12.1326 11.6979 15 8 15ZM13.9795 8.5C13.7254 11.5798 11.1453 14 8 14C6.223 14 4.62643 13.2275 3.52779 12H8.2C8.6 12 9 11.6 9 11.2V8.5H13.9795ZM7.5 4H3.52779C4.52233 2.88881 5.92491 2.15048 7.5 2.02054V4ZM8.5 2.02054V4.0717C8.77833 4.20445 9 4.50223 9 4.8V7.5H13.9795C13.739 4.5851 11.4149 2.26101 8.5 2.02054ZM4.5 10.5H3.5V5.5H5.5C6.32843 5.5 7 6.17157 7 7C7 7.82843 6.32843 8.5 5.5 8.5H4.5V10.5Z",
      key: 1,
    }),
  ]
);

export const OfficePowerPointRegular = createFluentIconExtended(
  "OfficePowerPointRegular",
  "16px",
  [
    React.createElement("path", {
      d: "M10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10L12 12.36L10 2Z",
      fill: "#ED6C47",
      key: 0,
    }),
    React.createElement("path", {
      d: "M10 2V10L14 12.59L18 10C18 8.94942 17.7931 7.90914 17.391 6.93853C16.989 5.96793 16.3997 5.08601 15.6569 4.34315C14.914 3.60028 14.0321 3.011 13.0615 2.60896C12.0909 2.20693 11.0506 2 10 2Z",
      fill: "#FF8F6B",
      key: 1,
    }),
    React.createElement("path", {
      d: "M18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10H18Z",
      fill: "#D35230",
      key: 2,
    }),
    React.createElement("path", {
      opacity: "0.5",
      d: "M12 6H3.08C2.15805 7.60101 1.81864 9.47177 2.11941 11.2946C2.42018 13.1175 3.34259 14.78 4.73 16H11C11.5304 16 12.0391 15.7893 12.4142 15.4142C12.7893 15.0391 13 14.5304 13 14V7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6Z",
      fill: "black",
      key: 3,
    }),
    React.createElement("path", {
      opacity: "0.1",
      d: "M12 6H3.08C2.15805 7.60101 1.81864 9.47177 2.11941 11.2946C2.42018 13.1175 3.34259 14.78 4.73 16H11C11.5304 16 12.0391 15.7893 12.4142 15.4142C12.7893 15.0391 13 14.5304 13 14V7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6Z",
      fill: "black",
      key: 4,
    }),
    React.createElement("path", {
      d: "M11 5H3C2.44772 5 2 5.44772 2 6V14C2 14.5523 2.44772 15 3 15H11C11.5523 15 12 14.5523 12 14V6C12 5.44772 11.5523 5 11 5Z",
      fill: "#C43E1C",
      key: 5,
    }),
    React.createElement("path", {
      d: "M7.33 7.00002C7.89142 6.96203 8.44705 7.133 8.89 7.48002C9.07651 7.65999 9.22146 7.87852 9.31473 8.12033C9.40801 8.36215 9.44735 8.62142 9.43 8.88002C9.42755 9.22975 9.33821 9.57338 9.17 9.88002C8.98641 10.1818 8.72353 10.4274 8.41 10.59C8.05202 10.7637 7.65777 10.8494 7.26 10.84H6.18V13H5.08V7.00002H7.33ZM6.18 10H7.18C7.47395 9.99882 7.75775 9.8924 7.98 9.70002C8.07972 9.59757 8.15631 9.47494 8.20461 9.34039C8.25291 9.20583 8.2718 9.06249 8.26 8.92002C8.26 8.26002 7.9 7.92002 7.17 7.92002H6.17L6.18 10Z",
      fill: "white",
      key: 6,
    }),
  ],
  "0 0 20 20"
);

export const OfficeWordMono = createFluentIcon("OfficeWordMono", "16px", [
  "M15 14.1V1.9C15 1.4 14.6 1 14.1 1H4.9C4.4 1 4 1.4 4 1.9V4H1.8C1.4 4 1 4.4 1 4.8V11.2C1 11.6 1.4 12 1.8 12H4V14.1C4 14.6 4.4 15 4.9 15H14.2C14.6 15 15 14.6 15 14.1ZM9 6H14V8H9V6ZM9 9H14V11H9V9ZM5 2H14V5H9V4.8C9 4.4 8.6 4 8.2 4H5V2ZM5 14V12H14V14H5ZM5.6 10.6L5 7.8L4.4 10.6H3L1.8 5.4H3.2L3.7 8.2L4.3 5.4H5.6L6.2 8.2L6.7 5.4H8.1L7 10.6H5.6Z",
]);

export const OfficeWordRegular = createFluentIconExtended(
  "OfficeWordRegular",
  "16px",
  [
    React.createElement("path", {
      key: "path1",
      d: "M15 4V1.875C14.9992 1.64318 14.9068 1.42108 14.7428 1.25716C14.5789 1.09323 14.3568 1.00079 14.125 1H4.875C4.64294 1 4.42038 1.09219 4.25628 1.25628C4.09219 1.42038 4 1.64294 4 1.875V4H15Z",
      fill: "#41A5EE",
    }),
    React.createElement("path", {
      key: "path2",
      d: "M15 4H4V8H15V4Z",
      fill: "#2B7CD3",
    }),
    React.createElement("path", {
      key: "path3",
      d: "M15 8H4V12H15V8Z",
      fill: "#185ABD",
    }),
    React.createElement("path", {
      key: "path4",
      d: "M4 12V14.125C4.00079 14.3568 4.09323 14.5789 4.25715 14.7428C4.42108 14.9068 4.64318 14.9992 4.875 15H14.125C14.3571 15 14.5796 14.9078 14.7437 14.7437C14.9078 14.5796 15 14.3571 15 14.125V12H4Z",
      fill: "#103F91",
    }),
    React.createElement("path", {
      key: "path5",
      opacity: "0.5",
      d: "M9.2 5H4V13H9.2C9.41217 13 9.61566 12.9157 9.76569 12.7657C9.91571 12.6157 10 12.4122 10 12.2V5.8C10 5.58783 9.91571 5.38434 9.76569 5.23431C9.61566 5.08429 9.41217 5 9.2 5V5Z",
      fill: "black",
    }),
    React.createElement("path", {
      key: "path6",
      d: "M8.2 4H1.8C1.35817 4 1 4.35817 1 4.8V11.2C1 11.6418 1.35817 12 1.8 12H8.2C8.64183 12 9 11.6418 9 11.2V4.8C9 4.35817 8.64183 4 8.2 4Z",
      fill: "#185ABD",
    }),
    React.createElement("path", {
      key: "path7",
      d: "M3.68198 9.232C3.69498 9.346 3.70398 9.445 3.70898 9.532H3.72398C3.73098 9.451 3.74298 9.354 3.76098 9.24C3.77898 9.126 3.79598 9.031 3.81298 8.953L4.54298 5.6H5.48798L6.24398 8.9C6.28993 9.10544 6.32332 9.3135 6.34398 9.523H6.35598C6.37049 9.32162 6.39687 9.12127 6.43498 8.923L7.03498 5.6H7.89998L6.83598 10.4H5.83598L5.10998 7.22C5.08898 7.129 5.06598 7.009 5.03898 6.862C5.01198 6.715 4.99998 6.608 4.99098 6.541H4.97798C4.96998 6.619 4.95298 6.735 4.92898 6.889C4.90498 7.043 4.88598 7.156 4.87098 7.23L4.19398 10.4H3.17298L2.10498 5.6H2.98098L3.63898 8.957C3.65398 9.027 3.66798 9.118 3.68198 9.232Z",
      fill: "white",
    }),
  ]
);

export const TeamsMono = createFluentIcon("TeamsMono", "16px", [
  "M14.25 7H11.56L11.52 7.01C11.48 7 11.44 7 11.39 7H9V5.95C10.14 5.72 11 4.71 11 3.5C11 2.12 9.88 1 8.5 1C7.12 1 6 2.12 6 3.5C6 3.67 6.02 3.84 6.05 4H1.8C1.36 4 1 4.36 1 4.8V11.2C1 11.64 1.36 12 1.8 12H5.02C5.19 13.69 6.62 15 8.35 15H8.65C10.06 15 11.27 14.13 11.76 12.9C11.99 12.97 12.24 13 12.5 13C13.88 13 15 12.04 15 10.85V7.65C15 7.29 14.66 7 14.25 7ZM7 3.5C7 2.67 7.67 2 8.5 2C9.33 2 10 2.67 10 3.5C10 4.15 9.58 4.71 9 4.91V4.8C9 4.36 8.64 4 8.2 4H7.09C7.03 3.84 7 3.68 7 3.5ZM8.65 14H8.35C7.17 14 6.2 13.14 6.03 12H8.2C8.64 12 9 11.64 9 11.2V8H11V11.65C11 11.94 10.95 12.21 10.86 12.47C10.52 13.36 9.66 14 8.65 14ZM14 10.85C14 11.47 13.31 12 12.5 12C12.32 12 12.14 11.97 11.98 11.93C12 11.84 12 11.75 12 11.65V8H14V10.85ZM13 6C14.1 6 15 5.1 15 4C15 2.9 14.1 2 13 2C11.9 2 11 2.9 11 4C11 5.1 11.9 6 13 6ZM13 3C13.55 3 14 3.45 14 4C14 4.55 13.55 5 13 5C12.45 5 12 4.55 12 4C12 3.45 12.45 3 13 3ZM3.81 10.88V6.5H2.06V5.12H6.94V6.5H5.19V10.88H3.81Z",
]);

export const TeamsRegular = createFluentIconExtended("TeamsRegular", "16px", [
  React.createElement("path", {
    key: "path1",
    d: "M14.25 7H11.56L10 7.65V10.85C10 12.04 11.12 13 12.5 13C13.88 13 15 12.04 15 10.85V7.65C15 7.29 14.66 7 14.25 7Z",
    fill: "#5059C9",
  }),
  React.createElement("path", {
    key: "path2",
    d: "M13 6C14.1046 6 15 5.10457 15 4C15 2.89543 14.1046 2 13 2C11.8954 2 11 2.89543 11 4C11 5.10457 11.8954 6 13 6Z",
    fill: "#5059C9",
  }),
  React.createElement("path", {
    key: "path3",
    d: "M8.35 15H8.66C10.5 15 12 13.5 12 11.65V7.61C12 7.27 11.73 7 11.39 7H5.61C5.27 7 5 7.27 5 7.61V11.65C5 13.5 6.5 15 8.35 15Z",
    fill: "#7B83EB",
  }),
  React.createElement("path", {
    key: "path4",
    d: "M8.5 6C9.88071 6 11 4.88071 11 3.5C11 2.11929 9.88071 1 8.5 1C7.11929 1 6 2.11929 6 3.5C6 4.88071 7.11929 6 8.5 6Z",
    fill: "#7B83EB",
  }),
  React.createElement("path", {
    key: "path5",
    opacity: "0.5",
    d: "M8.50001 6C9.04001 6 9.54001 5.83 9.95001 5.53C9.83001 5.22 9.54001 5 9.18001 5H6.51001C6.97001 5.6 7.68001 6 8.50001 6Z",
    fill: "black",
  }),
  React.createElement("path", {
    key: "path6",
    opacity: "0.5",
    d: "M5.61 7C5.27 7 5 7.27 5 7.61V11.65C5 12.13 5.1 12.58 5.29 13H8.37C9.27 13 10 12.28 10 11.4V7H5.61Z",
    fill: "black",
  }),
  React.createElement("path", {
    key: "path7",
    d: "M8.2 12H1.8C1.36 12 1 11.64 1 11.2V4.8C1 4.36 1.36 4 1.8 4H8.2C8.64 4 9 4.36 9 4.8V11.2C9 11.64 8.64 12 8.2 12Z",
    fill: "#4B53BC",
  }),
  React.createElement("path", {
    key: "path8",
    d: "M6.69006 6.25H4.94006V10.63H4.06006V6.25H2.31006V5.38H6.69006V6.25Z",
    fill: "white",
  }),
]);

export const OfficeOutlookMono = createFluentIcon("OfficeOutlookMono", "16px", [
  "M4.24386 9.43949C4.01865 9.30095 3.84055 9.09871 3.73251 8.85891C3.61037 8.57684 3.55147 8.2719 3.55987 7.96509C3.55797 7.6689 3.6167 7.37541 3.73251 7.10233C3.83962 6.85761 4.017 6.64947 4.24259 6.50382C4.4755 6.35339 4.74943 6.2774 5.02734 6.28616C5.30707 6.28096 5.58144 6.36253 5.81208 6.51938C6.0233 6.67677 6.18187 6.89341 6.26723 7.14118C6.37 7.40916 6.4206 7.69397 6.41633 7.9806C6.41965 8.26534 6.36631 8.54795 6.25937 8.81228C6.16442 9.05504 5.99756 9.2637 5.78069 9.41079C5.54912 9.5649 5.27482 9.64367 4.99594 9.63618C4.73103 9.64654 4.46907 9.57804 4.24386 9.43949ZM5 1C4.44772 1 4 1.44772 4 2V4H1.8C1.4 4 1 4.4 1 4.8V11.2C1 11.6 1.4 12 1.8 12H3V14C3 14.5523 3.44772 15 4 15H14C14.5523 15 15 14.5523 15 14V8.00855C15.0008 7.96214 14.9952 7.91531 14.9828 7.86943C14.9669 7.81063 14.9406 7.75611 14.9059 7.70801C14.8633 7.6486 14.8095 7.60097 14.7491 7.56636C14.6887 7.53163 14.6205 7.50913 14.5477 7.50224C14.5287 7.50041 14.5096 7.49965 14.4905 7.5H14V2C14 1.44772 13.5523 1 13 1H5ZM8 4H5V3H8V4ZM9 6V3H13V6H9ZM9 10.6295V7H13V8.29615L9 10.6295ZM8.5 12C8.58853 12 8.67547 11.9765 8.75194 11.9319L8.9512 11.8157L12.9558 14H4V12H8.5ZM14 13.4305L9.96032 11.227L14 8.87052V13.4305ZM3.67757 5.8276C4.10356 5.59977 4.58265 5.48718 5.06657 5.50116C5.51576 5.49034 5.95984 5.59759 6.35356 5.81204C6.71535 6.01112 7.01007 6.31113 7.20108 6.67479C7.40711 7.06811 7.50967 7.50654 7.49928 7.94952C7.50881 8.41321 7.40374 8.87219 7.19322 9.28645C6.99613 9.66407 6.69022 9.97516 6.31431 10.1803C5.90502 10.3992 5.44531 10.5091 4.98026 10.499C4.52337 10.5117 4.07121 10.4044 3.66972 10.1881C3.30128 9.98897 3.00083 9.68598 2.80649 9.31752C2.59903 8.93003 2.49377 8.49691 2.50046 8.05835C2.49227 7.60067 2.59451 7.14766 2.79866 6.73699C2.99035 6.35162 3.29723 6.0341 3.67757 5.8276Z",
]);

export const OfficeOutlookRegular = createFluentIconExtended(
  "OfficeOutlookRegular",
  "16px",
  [
    React.createElement("path", {
      d: "M14.8364 7.81681L9.40459 5.0687H9.33573C9.23148 5.0227 9.11644 4.99919 9 5.00002C8.88356 4.99919 8.76855 5.0227 8.66429 5.0687H8.59541L3.16361 7.81681C3.11367 7.84413 3.07242 7.88228 3.04379 7.9277C3.01517 7.97313 3.00012 8.02429 3.00005 8.07633C2.99901 8.12752 3.01367 8.17802 3.04248 8.22239C3.07129 8.26677 3.11316 8.30335 3.16361 8.32825L8.97418 12L14.8364 8.32825C14.8868 8.30335 14.9287 8.26677 14.9575 8.22239C14.9863 8.17802 15.001 8.12752 14.9999 8.07633C14.9999 8.02429 14.9848 7.97313 14.9562 7.9277C14.9276 7.88228 14.8863 7.84413 14.8364 7.81681Z",
      fill: "#0A2767",
      key: "key0",
    }),
    React.createElement("path", {
      d: "M13.1667 1H4.83333C4.61232 1 4.40037 1.10537 4.24409 1.29291C4.08781 1.48044 4 1.73478 4 2L9 4L14 2C14 1.73478 13.9122 1.48044 13.7559 1.29291C13.5996 1.10537 13.3877 1 13.1667 1Z",
      fill: "#0364B8",
      key: "key1",
    }),
    React.createElement("path", {
      d: "M9.00417 2H4V6.99584L8.99583 12H14V6.98751L9.00417 2Z",
      fill: "#28A8EA",
      key: "key2",
    }),
    React.createElement("path", {
      d: "M14 2H9V7H14V2Z",
      fill: "#50D9FF",
      key: "key3",
    }),
    React.createElement("path", {
      d: "M7.99333 12L4 11.9933V8H8L7.99333 12Z",
      fill: "#0078D4",
      key: "key4",
    }),
    React.createElement("path", {
      opacity: "0.5",
      d: "M8.98676 12L3 8.62235L3.4415 8.00696L9.00441 10.5105L14.5673 8L15 8.63635L8.98676 12Z",
      fill: "#0A2767",
      key: "key5",
    }),
    React.createElement("path", {
      d: "M14.8162 8.28985L8.71546 11.4517C8.58033 11.5319 8.42244 11.5746 8.26104 11.5746H8.23203C8.15497 11.5831 8.07707 11.5831 8 11.5746L10.1657 14.271L14.6519 15C14.7598 14.9282 14.8475 14.8343 14.908 14.726C14.9684 14.6176 15 14.4979 14.9999 14.3764V8C15.0011 8.0589 14.9846 8.117 14.9523 8.16806C14.9199 8.21911 14.8729 8.2612 14.8162 8.28985Z",
      fill: "#1490DF",
      key: "key6",
    }),
    React.createElement("path", {
      opacity: "0.1",
      d: "M9.19889 11L8.67678 11.2851C8.54165 11.369 8.38376 11.4137 8.22236 11.4138H8.23204C8.15497 11.4227 8.07707 11.4227 8 11.4138L10.1657 14.2368L14.6519 15C14.7598 14.9248 14.8476 14.8265 14.908 14.7131C14.9685 14.5997 15 14.4743 15 14.3471V14.0988L9.19889 11Z",
      fill: "black",
      key: "key7",
    }),
    React.createElement("path", {
      d: "M3.16733 8.28518C3.11574 8.25699 3.07291 8.21558 3.04345 8.16535C3.01398 8.11512 2.99898 8.05795 3.00005 8V14.2823C3.0001 14.4377 3.04923 14.5893 3.14068 14.7162C3.23213 14.8431 3.36138 14.9391 3.51068 14.9909C3.59533 15.003 3.68135 15.003 3.766 14.9909H14.551C14.7118 14.9928 14.8691 14.9443 15 14.8526L3.16733 8.28518Z",
      fill: "#28A8EA",
      key: "key8",
    }),
    React.createElement("path", {
      opacity: "0.5",
      d: "M8.44098 13C8.85446 13 9.251 12.8314 9.54338 12.5313C9.83575 12.2313 10 11.8243 10 11.4V5.8C10 5.58783 9.91786 5.38436 9.77168 5.23433C9.62549 5.0843 9.42723 5 9.22049 5H3.76393V7.45601L3.15591 7.81602C3.10932 7.84173 3.07028 7.87975 3.04287 7.92617C3.01545 7.9726 3.00065 8.0257 3 8.07998V8.99199V12.992L8.44098 13Z",
      fill: "black",
      key: "key9",
    }),
    React.createElement("path", {
      d: "M8.2 12H1.8C1.4 12 1 11.6 1 11.2V4.8C1 4.4 1.4 4 1.8 4H8.2C8.6 4 9 4.4 9 4.8V11.2C9 11.6 8.6 12 8.2 12Z",
      fill: "#0078D4",
      key: "key10",
    }),
    React.createElement("path", {
      d: "M2.79866 6.73699C2.99035 6.35162 3.29723 6.0341 3.67757 5.8276C4.10356 5.59977 4.58265 5.48718 5.06657 5.50116C5.51576 5.49034 5.95984 5.59759 6.35356 5.81204C6.71535 6.01112 7.01007 6.31113 7.20108 6.67479C7.40711 7.06811 7.50967 7.50654 7.49928 7.94952C7.50881 8.41321 7.40374 8.87219 7.19322 9.28645C6.99613 9.66407 6.69022 9.97516 6.31431 10.1803C5.90502 10.3992 5.44531 10.5091 4.98026 10.499C4.52337 10.5117 4.07121 10.4044 3.66972 10.1881C3.30128 9.98897 3.00083 9.68598 2.80649 9.31752C2.59903 8.93003 2.49377 8.49691 2.50046 8.05835C2.49227 7.60067 2.59451 7.14766 2.79866 6.73699ZM3.73251 8.85891C3.84055 9.09871 4.01865 9.30095 4.24386 9.43949C4.46907 9.57804 4.73103 9.64654 4.99594 9.63618C5.27482 9.64367 5.54912 9.5649 5.78069 9.41079C5.99756 9.2637 6.16442 9.05504 6.25937 8.81228C6.36631 8.54795 6.41965 8.26534 6.41633 7.9806C6.4206 7.69397 6.37 7.40916 6.26723 7.14118C6.18187 6.89341 6.0233 6.67677 5.81208 6.51938C5.58144 6.36253 5.30707 6.28096 5.02734 6.28616C4.74943 6.2774 4.4755 6.35339 4.24259 6.50382C4.017 6.64947 3.83962 6.85761 3.73251 7.10233C3.6167 7.37541 3.55797 7.6689 3.55987 7.96509C3.55147 8.2719 3.61037 8.57684 3.73251 8.85891Z",
      fill: "white",
      key: "key11",
    }),
  ]
);

export const OfficeSharepointMono = createFluentIcon(
  "OfficeSharepointMono",
  "16px",
  [
    "M9 4.75V6.05051C9.5251 5.51465 10.2211 5.14691 10.9998 5.03547L11 5C11 3.34315 9.65685 2 8 2C6.69378 2 5.58254 2.83481 5.17071 4H8.25C8.66421 4 9 4.33579 9 4.75ZM8 14C9.10457 14 10 13.1046 10 12C10 11.2597 9.5978 10.6134 9 10.2676V11.25C9 11.6642 8.66421 12 8.25 12H6C6 13.1046 6.89543 14 8 14ZM8 15C6.34315 15 5 13.6569 5 12H1.75C1.33579 12 1 11.6642 1 11.25V4.75C1 4.33579 1.33579 4 1.75 4H4.12602C4.57006 2.27477 6.13616 1 8 1C10.2091 1 12 2.79086 12 5L11.9998 5.03542C13.6961 5.27797 15 6.73671 15 8.5C15 10.433 13.433 12 11.5 12C11.3302 12 11.1632 11.9879 10.9998 11.9645L11 12C11 13.6569 9.65685 15 8 15ZM11.5 6C10.1193 6 9 7.11929 9 8.5C9 8.74621 9.03559 8.98412 9.10191 9.20884C9.87244 9.51328 10.4867 10.1276 10.7912 10.8981C11.0159 10.9644 11.2538 11 11.5 11C12.8807 11 14 9.88071 14 8.5C14 7.11929 12.8807 6 11.5 6ZM3.39784 7.47076C3.49813 7.65445 3.64105 7.81138 3.81459 7.92836C4.03632 8.08722 4.2747 8.22148 4.52549 8.32876C4.83601 8.4595 5.06481 8.5739 5.22823 8.65561C5.36642 8.72601 5.49315 8.81692 5.60412 8.92527C5.64989 8.96539 5.6872 9.01424 5.71386 9.06896C5.74052 9.12368 5.75599 9.18317 5.75937 9.24395C5.76318 9.33201 5.74319 9.41947 5.70148 9.49712C5.65978 9.57477 5.59792 9.63975 5.5224 9.6852C5.30271 9.80585 5.05358 9.86247 4.80332 9.84863C4.52611 9.8441 4.25097 9.80008 3.98618 9.71789C3.72572 9.64509 3.48162 9.52304 3.2671 9.35835V10.3553C3.49456 10.4529 3.73341 10.5215 3.97801 10.5595C4.25678 10.5983 4.53872 10.6093 4.81966 10.5922C5.14701 10.597 5.47287 10.5473 5.78389 10.4451C6.05356 10.3612 6.29053 10.1956 6.46211 9.9712C6.63579 9.73494 6.72501 9.44714 6.71542 9.15406C6.72602 8.91288 6.67244 8.67321 6.56017 8.4595C6.44769 8.27211 6.29399 8.11282 6.11074 7.99373C5.87166 7.84434 5.62014 7.71584 5.35897 7.60968H5.26909C5.00761 7.49528 4.80332 7.40539 4.67258 7.33185C4.55476 7.27319 4.44715 7.19593 4.3539 7.10305C4.27693 7.01831 4.23591 6.90696 4.2395 6.79254C4.23862 6.70009 4.26435 6.60934 4.31361 6.53111C4.36287 6.45288 4.43358 6.39045 4.51732 6.35128C4.73533 6.24278 4.97664 6.18947 5.22006 6.19603C5.45175 6.19673 5.6824 6.22694 5.90646 6.28591C6.11378 6.33758 6.31212 6.42022 6.4948 6.53105V5.59135C6.07732 5.44782 5.63658 5.38407 5.19555 5.4034C4.86215 5.39776 4.53033 5.4503 4.21498 5.55866C3.94609 5.65336 3.70664 5.81674 3.52042 6.0326C3.33604 6.26415 3.24041 6.55393 3.25076 6.84974C3.24524 7.06598 3.29592 7.27996 3.39784 7.47076Z",
  ]
);

export const OfficeSharepointRegular = createFluentIconExtended(
  "OfficeSharepointRegular",
  "16px",
  [
    React.createElement("path", {
      key: "path1",
      d: "M8 9C10.2091 9 12 7.20914 12 5C12 2.79086 10.2091 1 8 1C5.79086 1 4 2.79086 4 5C4 7.20914 5.79086 9 8 9Z",
      fill: "#036C70",
    }),
    React.createElement("path", {
      key: "path2",
      d: "M11.5 12C13.433 12 15 10.433 15 8.5C15 6.567 13.433 5 11.5 5C9.567 5 8 6.567 8 8.5C8 10.433 9.567 12 11.5 12Z",
      fill: "#1A9BA1",
    }),
    React.createElement("path", {
      key: "path3",
      d: "M8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15Z",
      fill: "#37C6D0",
    }),
    React.createElement("path", {
      key: "path4",
      opacity: "0.5",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.17068 13H8.24998C9.21648 13 9.99998 12.2165 9.99998 11.25V5.75C9.99998 5.33579 9.66419 5 9.24998 5H4.74998C4.414 5 4.12962 5.22092 4.03418 5.52543C4.29146 7.48626 5.96894 9 7.99998 9C6.34312 9 4.99998 10.3431 4.99998 12C4.99998 12.3506 5.06013 12.6872 5.17068 13ZM7.99998 9L8.0354 8.99985L8.03545 9.00021L7.99998 9Z",
      fill: "black",
    }),
    React.createElement("path", {
      key: "path5",
      d: "M8.2 4H1.8C1.35817 4 1 4.35817 1 4.8V11.2C1 11.6418 1.35817 12 1.8 12H8.2C8.64183 12 9 11.6418 9 11.2V4.8C9 4.35817 8.64183 4 8.2 4Z",
      fill: "#038387",
    }),
    React.createElement("path", {
      key: "path6",
      d: "M3.78884 7.90884C3.60317 7.78148 3.4604 7.63067 3.3612 7.4564C3.262 7.28213 3.21173 7.07635 3.21173 6.83774C3.21173 6.52002 3.30423 6.25258 3.48923 6.03676C3.67355 5.82026 3.91887 5.66006 4.22519 5.55617C4.5315 5.45228 4.86664 5.39999 5.23127 5.39999C5.79028 5.39999 6.23199 5.46233 6.55708 5.58566V6.52204C6.38415 6.41479 6.18373 6.33302 5.95718 6.27671C5.73063 6.22041 5.4967 6.19226 5.25607 6.19226C4.96651 6.19226 4.72588 6.2432 4.53553 6.34508C4.34517 6.44696 4.24999 6.59107 4.24999 6.77808C4.24999 6.89538 4.2902 6.99726 4.37064 7.08507C4.45174 7.1722 4.56033 7.25063 4.69706 7.31832C4.8338 7.38602 5.03756 7.47584 5.30902 7.58777C5.35527 7.60453 5.38477 7.61593 5.39616 7.6233C5.71655 7.754 5.97394 7.88068 6.16765 8.00335C6.36203 8.12601 6.51351 8.2795 6.62344 8.46248C6.73336 8.64614 6.78832 8.87738 6.78832 9.15555C6.78832 9.49672 6.70186 9.77488 6.52893 9.98937C6.35599 10.2052 6.12408 10.36 5.83452 10.4559C5.54496 10.5517 5.21519 10.6 4.84586 10.6C4.53016 10.6 4.23189 10.5752 3.95037 10.5263C3.66819 10.4773 3.42555 10.407 3.22246 10.3158V9.32714C3.42086 9.4746 3.66685 9.59123 3.95909 9.67769C4.25066 9.76416 4.52078 9.80773 4.76878 9.80773C5.09387 9.80773 5.33852 9.75545 5.5034 9.65155C5.66829 9.54766 5.75074 9.40087 5.75074 9.21118C5.75074 9.08316 5.70449 8.97055 5.61199 8.8747C5.51949 8.77885 5.39214 8.69038 5.22993 8.60793C5.06705 8.52683 4.8271 8.41892 4.50938 8.28553C4.21446 8.16153 3.9745 8.03619 3.78884 7.90884Z",
      fill: "white",
    }),
  ]
);

export const OfficeExcelMono = createFluentIcon("OfficeExcelMono", "16px", [
  "M14.6 1C15.1 1 15.5 1.4 15.5 1.9V14.1C15.5 14.6 15.1 15 14.7 15H5.4C4.9 15 4.5 14.6 4.5 14.1V12H2.3C1.9 12 1.5 11.6 1.5 11.2V4.8C1.5 4.4 1.9 4 2.3 4H4.5V1.9C4.5 1.4 4.9 1 5.4 1H14.6ZM10.5 14H14.5V12H10.5V14ZM9.5 12H5.5V14H9.5V12ZM10.5 11H14.5V9H10.5V11ZM10.5 8H14.5V6H10.5V8ZM10.5 5H14.5V2H10.5V5ZM9.5 2H5.5V4H8.7C9.1 4 9.5 4.4 9.5 4.8V2ZM2.56504 5L4.35366 8L2.5 11H4.28862L5.5 8.92578L6.73171 11H8.5L6.64228 8L8.45122 5H6.6748L5.5 7.09766L4.35366 5H2.56504Z",
]);

export const OfficeExcelRegular = createFluentIconExtended(
  "OfficeExcelRegular",
  "16px",
  [
    React.createElement("path", {
      key: "path1",
      d: "M11 2.00099V3.5H14L15 4V8L9.46899 9L4 8V1.875C4 1.64294 4.10755 1.42038 4.29899 1.25628C4.49044 1.09219 4.75009 1 5.02083 1C8.57269 1 10 1.00099 10 1.00099L11 2.00099Z",
      fill: "#21A366",
    }),
    React.createElement("path", {
      key: "path2",
      d: "M15 4V1.875C14.9992 1.64318 14.9068 1.42108 14.7428 1.25716C14.5789 1.09323 14.3568 1.00079 14.125 1C10.75 1 10 1 10 1V4H15Z",
      fill: "#33C481",
    }),
    React.createElement("path", {
      key: "path3",
      d: "M15 8H4V12L9.5 13L15 12V8Z",
      fill: "#107C41",
    }),
    React.createElement("path", {
      key: "path4",
      d: "M4 12V14.125C4.00079 14.3568 4.09323 14.5789 4.25715 14.7428C4.42108 14.9068 4.64318 14.9992 4.875 15H14.125C14.3571 15 14.5796 14.9078 14.7437 14.7437C14.9078 14.5796 15 14.3571 15 14.125V12H4Z",
      fill: "#185C37",
    }),
    React.createElement("path", {
      key: "path5",
      opacity: "0.5",
      d: "M9.2 5H4V13H9.2C9.41217 13 9.61566 12.9157 9.76569 12.7657C9.91571 12.6157 10 12.4122 10 12.2V5.8C10 5.58783 9.91571 5.38434 9.76569 5.23431C9.61566 5.08429 9.41217 5 9.2 5V5Z",
      fill: "black",
    }),
    React.createElement("path", {
      key: "path6",
      d: "M8.2 4H1.8C1.35817 4 1 4.35817 1 4.8V11.2C1 11.6418 1.35817 12 1.8 12H8.2C8.64183 12 9 11.6418 9 11.2V4.8C9 4.35817 8.64183 4 8.2 4Z",
      fill: "#107C41",
    }),
    React.createElement("path", {
      key: "path7",
      d: "M4.03434 5.61523H2.83816L4.25862 8.00759L2.80078 10.3999H3.99696L5 8.67732L6.01239 10.3999H7.19922L5.73203 8.00759L7.1743 5.61523H5.98124L5 7.38146L4.03434 5.61523Z",
      fill: "white",
    }),
  ]
);

export const OfficeOneDriveMono = createFluentIcon(
  "OfficeOneDriveMono",
  "16px",
  [
    "M4.25208 5.00865C2.43477 5.13582 1 6.65036 1 8.5C1 9.34988 1.30355 10.1302 1.80763 10.7364C2.44885 11.5077 3.41715 12 4.5 12H12C12.9897 12 13.8675 11.5202 14.4131 10.7827C14.7818 10.2843 15 9.6669 15 9C15 7.42642 13.7885 6.13582 12.2473 6.01005C11.6324 4.25724 9.96357 3 8 3C6.43541 3 5.05789 3.79871 4.25208 5.00865ZM5.37714 5.18239C6.01884 4.45669 6.95628 4 8 4C9.45058 4 10.696 4.88282 11.2265 6.14099C11.0183 6.20028 10.7899 6.27524 10.5506 6.35971C10.1022 6.518 9.58389 6.7213 9.03204 6.94981C8.16317 6.46705 7.30054 6.01286 6.55494 5.66694C6.152 5.48 5.77616 5.32135 5.44764 5.20659C5.4241 5.19837 5.4006 5.1903 5.37714 5.18239ZM7.85409 7.44512C5.80885 8.31048 3.4257 9.33855 2.3629 9.79809C2.13251 9.41979 2 8.97577 2 8.5C2 7.11929 3.11929 6 4.5 6C4.50445 6 4.50954 6.00009 4.5153 6.00032C4.62399 6.00454 4.82146 6.04711 5.11786 6.15065C5.40396 6.25059 5.74731 6.39463 6.13408 6.57407C6.65502 6.81576 7.24187 7.11565 7.85409 7.44512ZM3.09756 10.57C4.4296 9.99463 6.9834 8.89491 8.96846 8.06038C10.4004 8.86856 11.8079 9.7228 13.2185 10.5862C12.8809 10.846 12.4584 11 12 11H4.5C3.98022 11 3.49763 10.8416 3.09756 10.57ZM13.837 9.79236C12.6165 9.04502 11.3891 8.29802 10.1435 7.57959C10.408 7.47605 10.6563 7.38287 10.8834 7.30269C11.3792 7.12768 11.7361 7.02861 11.9355 7.00476C11.967 7.00099 11.988 7 12 7C13.1046 7 14 7.89543 14 9C14 9.28187 13.9419 9.5496 13.837 9.79236Z",
  ]
);

export const OfficeOneDriveRegular = createFluentIconExtended(
  "OfficeOneDriveRegular",
  "16px",
  [
    React.createElement("path", {
      key: "path1",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.94531 7.7999H12.966C12.966 7.7999 12.966 6.49244 12.966 6.34981C12.4138 4.13648 10.4543 2.5 8.12152 2.5C6.37565 2.5 4.83965 3.41719 3.94531 4.80618C3.94531 5.77024 3.94531 7.7999 3.94531 7.7999Z",
      fill: "#0364B8",
    }),
    React.createElement("path", {
      key: "path2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.10151 5.41559L6.10135 5.41615C5.49065 5.0291 4.771 4.80515 4.00009 4.80515C3.98292 4.80515 3.96606 4.80627 3.94896 4.80648C1.76346 4.83463 0 6.65724 0 8.90267C0 9.77382 0.266171 10.5808 0.718671 11.2448H9.4604V7.47653L6.10151 5.41559Z",
      fill: "#0078D4",
    }),
    React.createElement("path", {
      key: "path3",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9702 6.35013C12.8976 6.34518 12.8246 6.34175 12.7508 6.34175C12.293 6.34175 11.8576 6.43916 11.4626 6.61412L9.46094 7.47656V11.2508H15.6121C15.86 10.7807 16.0009 10.2427 16.0009 9.67098C16.0009 7.90788 14.6628 6.46582 12.9702 6.35013Z",
      fill: "#1490DF",
    }),
    React.createElement("path", {
      key: "path4",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.7735 9.50909L11.9434 8.99979L10.0409 7.83243L9.46048 7.47633L7.92939 8.13632L4.99757 9.40015L3.68082 9.96775L0.71875 11.2446C1.44171 12.3054 2.64141 13 4.00017 13H12.7504C13.9872 13 15.0625 12.2922 15.6117 11.2506L12.7735 9.50909Z",
      fill: "#28A8EA",
    }),
  ]
);

export const CopilotRegular = createFluentIcon("CopilotRegular", "16px", [
  "M6.77889 14.9999H11.5938C12.6162 14.9999 13.3728 14.3436 13.9211 13.5283C14.4714 12.71 14.8793 11.638 15.1961 10.5875C15.5592 9.38351 16.0165 7.86674 15.9995 6.64477C15.991 6.02748 15.8622 5.40417 15.4636 4.93124C15.0503 4.44087 14.4256 4.2026 13.6254 4.2026H13.1916C12.8184 4.17148 12.4946 3.92276 12.3697 3.56318L11.936 2.31371C11.663 1.52708 10.9239 1 10.0939 1H9.23663L9.22114 1.00006H4.4062C3.38378 1.00006 2.62719 1.65641 2.07891 2.47169C1.52859 3.29001 1.12069 4.36198 0.803872 5.41253C0.440784 6.61649 -0.0164514 8.13326 0.000455415 9.35523C0.00899617 9.97252 0.137844 10.5958 0.536424 11.0688C0.949698 11.5591 1.57443 11.7974 2.37461 11.7974H2.8084C3.18159 11.8285 3.50544 12.0772 3.63026 12.4368L4.06399 13.6863C4.33704 14.4729 5.07612 15 5.90608 15H6.76338C6.76855 15 6.77372 15 6.77889 14.9999ZM7.77534 6.65792L8.0257 5.87203C8.15212 5.4752 8.51962 5.20589 8.93472 5.20589H9.46421C9.3917 5.33608 9.33322 5.47609 9.29105 5.62418C9.02949 6.54282 8.62995 7.94131 8.22459 9.34234L7.97431 10.128C7.84789 10.5248 7.48039 10.7941 7.06529 10.7941H6.53579C6.6083 10.6639 6.66678 10.5239 6.70895 10.3758C6.9705 9.45723 7.37 8.05887 7.77534 6.65792ZM7.52454 11.7392C7.39824 12.1671 7.2841 12.5504 7.16311 12.8883C7.02668 13.2694 6.89317 13.5582 6.74854 13.7632C6.66221 13.8855 6.49575 13.9999 6.12413 13.9999C6.12151 13.9999 6.11889 14 6.11627 14H5.90608C5.50003 14 5.13845 13.7421 5.00486 13.3573L4.57113 12.1078C4.53341 11.9992 4.4868 11.8954 4.43229 11.7974H4.8318C4.8699 11.7974 4.9078 11.7963 4.94546 11.7941L7.06529 11.7941C7.22255 11.7941 7.37648 11.7752 7.52454 11.7392ZM11.4289 3.89218C11.4666 4.00084 11.5132 4.10455 11.5677 4.2026H11.1682C11.1301 4.2026 11.0922 4.20371 11.0545 4.2059L8.93472 4.2059C8.77745 4.2059 8.62353 4.22481 8.47546 4.26079C8.60176 3.83287 8.7159 3.4496 8.83689 3.11166C8.97332 2.73061 9.10684 2.44177 9.25146 2.23683C9.33779 2.11449 9.50425 2.00005 9.87587 2.00005L9.88372 1.99999H10.0939C10.5 1.99999 10.8616 2.25786 10.9952 2.64271L11.4289 3.89218ZM1.75748 5.70223C2.06577 4.67999 2.43925 3.7233 2.90473 3.03115C3.37224 2.33597 3.86586 2.00005 4.4062 2.00005H8.23064C8.10425 2.23835 7.99671 2.5013 7.89926 2.77348C7.76184 3.15729 7.63428 3.58978 7.50273 4.03582L7.47356 4.1347C6.89556 6.09246 6.15673 8.67597 5.75096 10.101C5.63358 10.5133 5.25841 10.7974 4.8318 10.7974H2.37461C1.77299 10.7974 1.46751 10.6251 1.29712 10.423C1.11203 10.2033 1.00376 9.85209 0.996696 9.34134C0.982388 8.30722 1.37998 6.95398 1.75748 5.70223ZM13.0953 12.9689C12.6278 13.664 12.1341 13.9999 11.5938 13.9999H7.76936C7.89575 13.7617 8.00329 13.4987 8.10074 13.2265C8.23816 12.8427 8.36572 12.4102 8.49727 11.9642L8.52645 11.8653C9.10445 9.90754 9.84327 7.32403 10.249 5.89895C10.3664 5.48671 10.7416 5.20259 11.1682 5.20259H13.6254C14.227 5.20259 14.5325 5.37487 14.7029 5.57705C14.888 5.79666 14.9962 6.14791 15.0033 6.65866C15.0176 7.69278 14.62 9.04602 14.2425 10.2978C13.9342 11.32 13.5608 12.2767 13.0953 12.9689Z",
]);

export const CopilotFilled = createFluentIconExtended("CopilotFilled", "20px", [
  React.createElement("path", {
    d: "M13.6692 3.98972C13.4685 3.39807 12.9132 3 12.2885 3L11.388 3C10.6869 3 10.0851 3.49905 9.95529 4.18803L9.02399 9.13282L9.48701 7.54883C9.66871 6.92722 10.2387 6.5 10.8863 6.5L13.7651 6.5L15.0096 8.12858L16.1176 6.5L15.5654 6.5C14.9406 6.5 14.3853 6.10193 14.1847 5.51027L13.6692 3.98972Z",
    fill: "url(#paint0_radial_1202_2379)",
    key: 0,
  }),
  React.createElement("path", {
    d: "M6.50315 16.0036C6.70173 16.5987 7.25872 17 7.88604 17H9.35227C10.148 17 10.7968 16.3619 10.8099 15.5662L10.8831 11.1348L10.4977 12.4516C10.3159 13.073 9.74601 13.5 9.09855 13.5L6.20863 13.5L4.97828 12.4147L4.07037 13.5H4.61725C5.24457 13.5 5.80155 13.9013 6.00014 14.4964L6.50315 16.0036Z",
    fill: "url(#paint1_radial_1202_2379)",
    key: 1,
  }),
  React.createElement("path", {
    d: "M12.0004 3H6.16755C4.50102 3 3.50109 5.20235 2.83448 7.40471C2.04471 10.0139 1.01129 13.5035 4.00105 13.5035H6.69024C7.34194 13.5035 7.91403 13.0727 8.09306 12.4461C8.52129 10.9472 9.32308 8.15282 9.94795 6.04403C10.2543 5.01026 10.5094 4.12243 10.901 3.56954C11.1206 3.25958 11.4865 3 12.0004 3Z",
    fill: "url(#paint2_linear_1202_2379)",
    key: 2,
  }),
  React.createElement("path", {
    d: "M12.0004 3H6.16755C4.50102 3 3.50109 5.20235 2.83448 7.40471C2.04471 10.0139 1.01129 13.5035 4.00105 13.5035H6.69024C7.34194 13.5035 7.91403 13.0727 8.09306 12.4461C8.52129 10.9472 9.32308 8.15282 9.94795 6.04403C10.2543 5.01026 10.5094 4.12243 10.901 3.56954C11.1206 3.25958 11.4865 3 12.0004 3Z",
    fill: "url(#paint3_linear_1202_2379)",
    key: 3,
  }),
  React.createElement("path", {
    d: "M7.99957 17H13.8325C15.499 17 16.4989 14.7979 17.1655 12.5958C17.9553 9.98689 18.9887 6.49768 15.999 6.49768H13.3097C12.658 6.49768 12.086 6.92848 11.9069 7.55508C11.4787 9.05377 10.6769 11.8478 10.0521 13.9563C9.74573 14.99 9.49057 15.8777 9.09897 16.4305C8.87943 16.7405 8.51352 17 7.99957 17Z",
    fill: "url(#paint4_radial_1202_2379)",
    key: 4,
  }),
  React.createElement("path", {
    d: "M7.99957 17H13.8325C15.499 17 16.4989 14.7979 17.1655 12.5958C17.9553 9.98689 18.9887 6.49768 15.999 6.49768H13.3097C12.658 6.49768 12.086 6.92848 11.9069 7.55508C11.4787 9.05377 10.6769 11.8478 10.0521 13.9563C9.74573 14.99 9.49057 15.8777 9.09897 16.4305C8.87943 16.7405 8.51352 17 7.99957 17Z",
    fill: "url(#paint5_linear_1202_2379)",
    key: 5,
  }),
  React.createElement("defs", null, [
    React.createElement(
      "radialGradient",
      {
        id: "paint0_radial_1202_2379",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform:
          "translate(15.0847 9.1729) rotate(-128.772) scale(6.41931 6.01261)",
        key: 6,
      },
      [
        React.createElement("stop", {
          offset: 0.0955758,
          stopColor: "#00AEFF",
          key: 7,
        }),
        React.createElement("stop", {
          offset: 0.773185,
          stopColor: "#2253CE",
          key: 8,
        }),
        React.createElement("stop", {
          offset: 1,
          stopColor: "#0736C4",
          key: 9,
        }),
      ]
    ),
  ]),
  React.createElement(
    "radialGradient",
    {
      id: "paint1_radial_1202_2379",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform:
        "translate(5.30634 13.0661) rotate(51.1538) scale(5.67928 5.53958)",
      key: 10,
    },
    [
      React.createElement("stop", { color: "#FFB657", key: 11 }),
      React.createElement("stop", {
        offset: 0.633728,
        stopColor: "#FF5F3D",
        key: 12,
      }),
      React.createElement("stop", {
        offset: 0.923392,
        stopColor: "#C02B3C",
        key: 13,
      }),
    ]
  ),
  React.createElement(
    "linearGradient",
    {
      id: "paint2_linear_1202_2379",
      x1: 5.81844,
      y1: 4.2727,
      x2: 6.65052,
      y2: 13.8998,
      gradientUnits: "userSpaceOnUse",
      key: 14,
    },
    [
      React.createElement("stop", {
        offset: 0.156162,
        stopColor: "#0D91E1",
        key: 15,
      }),
      React.createElement("stop", {
        offset: 0.487484,
        stopColor: "#52B471",
        key: 16,
      }),
      React.createElement("stop", {
        offset: 0.652394,
        stopColor: "#98BD42",
        key: 17,
      }),
      React.createElement("stop", {
        offset: 0.937361,
        stopColor: "#FFC800",
        key: 18,
      }),
    ]
  ),
  React.createElement(
    "linearGradient",
    {
      id: "paint3_linear_1202_2379",
      x1: 6.54577,
      y1: 3,
      x2: 7.00014,
      y2: 13.5035,
      gradientUnits: "userSpaceOnUse",
      key: 19,
    },
    [
      React.createElement("stop", { stopColor: "#3DCBFF", key: 20 }),
      React.createElement("stop", {
        offset: 0.246674,
        stopColor: "#0588F7",
        stopOpacity: 0,
        key: 20,
      }),
    ]
  ),
  React.createElement(
    "radialGradient",
    {
      id: "paint4_radial_1202_2379",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform:
        "translate(16.2986 5.46943) rotate(109.281) scale(13.9554 16.7229)",
      key: 21,
    },
    [
      React.createElement("stop", {
        offset: 0.0661714,
        stopColor: "#8C48FF",
        key: 22,
      }),
      React.createElement("stop", {
        offset: 0.5,
        stopColor: "#F2598A",
        key: 23,
      }),
      React.createElement("stop", {
        offset: 0.895833,
        stopColor: "#FFB152",
        key: 24,
      }),
    ]
  ),
  React.createElement(
    "linearGradient",
    {
      id: "paint5_linear_1202_2379",
      x1: 16.7594,
      y1: 5.85649,
      x2: 16.7534,
      y2: 8.71696,
      gradientUnits: "userSpaceOnUse",
      key: 25,
    },
    [
      React.createElement("stop", {
        offset: 0.0581535,
        stopColor: "#F8ADFA",
        key: 26,
      }),
      React.createElement("stop", {
        offset: 0.708063,
        stopColor: "#A86EDD",
        stopOpacity: 0,
        key: 27,
      }),
    ]
  ),
]);

export const OneNoteRegular = createFluentIcon("OneNoteRegular", "16px", [
  "M4 2C4 1.44772 4.44771 1 5 1H14C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H5C4.44772 15 4 14.5523 4 14V12H1.75C1.33579 12 1 11.6642 1 11.25V4.75C1 4.33579 1.33579 4 1.75 4H4V2ZM5 14H11V5H14V2L5 2V4H8.25C8.66421 4 9 4.33579 9 4.75V11.25C9 11.6642 8.66421 12 8.25 12H5V14ZM14 6H12V8H14V6ZM14 9H12V11H14V9ZM14 12H12V14H14V12ZM4.06497 5.60001H3V10.4H3.91194V7.57628C3.91194 7.25385 3.90298 7.02081 3.88437 6.87714H3.9016C3.9402 6.96188 4.005 7.07245 4.0953 7.20685L6.00327 10.4H7V5.60001H6.0915V8.52105C6.0915 8.82825 6.10184 9.04078 6.12183 9.15796H6.10874C6.09033 9.12564 6.06972 9.07126 6.04599 9.00863C6.0075 8.90707 5.96079 8.78383 5.90195 8.69783L4.06497 5.60001Z",
]);

export const OneNoteColor = createFluentIconExtended("OneNoteColor", "16px", [
  React.createElement("rect", {
    x: "4",
    y: "1",
    width: "11",
    height: "14",
    rx: "1",
    fill: "#CA64EA",
    key: 0,
  }),
  React.createElement("path", {
    d: "M15 11H11V15H14C14.5523 15 15 14.5523 15 14V11Z",
    fill: "#7719AA",
    key: 1,
  }),
  React.createElement("path", {
    d: "M15 7H11V11H15V7Z",
    fill: "#9332BF",
    key: 2,
  }),
  React.createElement("path", {
    d: "M15 3H11V7H15V3Z",
    fill: "#AE4BD5",
    key: 3,
  }),
  React.createElement("path", {
    opacity: "0.5",
    d: "M9.2 5H4V13H9.2C9.41217 13 9.61566 12.9157 9.76569 12.7657C9.91571 12.6157 10 12.4122 10 12.2V5.8C10 5.58783 9.91571 5.38434 9.76569 5.23431C9.61566 5.08429 9.41217 5 9.2 5Z",
    fill: "black",
    key: 4,
  }),
  React.createElement("path", {
    d: "M8.2 4H1.8C1.35817 4 1 4.35817 1 4.8V11.2C1 11.6418 1.35817 12 1.8 12H8.2C8.64183 12 9 11.6418 9 11.2V4.8C9 4.35817 8.64183 4 8.2 4Z",
    fill: "#7719AA",
    key: 5,
  }),
  React.createElement("path", {
    d: "M3 5.6H4.06497L5.90195 8.69782C5.99707 8.83685 6.06049 9.07321 6.10874 9.15796H6.12183C6.10184 9.04077 6.0915 8.82825 6.0915 8.52105V5.6H7V10.4H6.00327L4.0953 7.20684C4.005 7.07244 3.9402 6.96187 3.9016 6.87713H3.88437C3.90298 7.0208 3.91194 7.25385 3.91194 7.57627V10.4H3V5.6Z",
    fill: "white",
    key: 6,
  }),
]);

export const LoopRegular = createFluentIcon("LoopRegular", "16px", [
  "M2 14V8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14H2ZM5.36071 13H8C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8V12.9649C4.57902 12.7426 6 11.4767 6 9.5V8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10H6.97549C6.84681 11.2925 6.22234 12.3132 5.36071 13ZM7 9H8C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8V9Z",
]);

export const LoopColor = createFluentIconExtended("LoopColor", "16px", [
  React.createElement("path", {
    d: "M8 2C4.68629 2 2 4.68629 2 8V14H8C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8 5.9C9.1598 5.9 10.1 6.8402 10.1 8C10.1 9.1598 9.1598 10.1 8 10.1H5.9V8C5.9 6.8402 6.8402 5.9 8 5.9Z",
    fill: "url(#paint0_linear_1_56)",
    key: 0,
  }),
  React.createElement("path", {
    d: "M14 8C14 11.3137 11.3137 14 8 14H2C2 11.8461 3.74609 10.1 5.9 10.1H8C9.1598 10.1 10.1 9.1598 10.1 8L14 8Z",
    fill: "url(#paint1_linear_1_56)",
    key: 1,
  }),
  React.createElement("path", {
    d: "M14 8C14 11.3137 11.3137 14 8 14H2C2 11.8461 3.74609 10.1 5.9 10.1H8C9.1598 10.1 10.1 9.1598 10.1 8L14 8Z",
    fill: "url(#paint2_radial_1_56)",
    "fill-opacity": "0.56",
    key: 2,
  }),
  React.createElement("path", {
    d: "M14 8C14 11.3137 11.3137 14 8 14H2C2 11.8461 3.74609 10.1 5.9 10.1H8C9.1598 10.1 10.1 9.1598 10.1 8L14 8Z",
    fill: "url(#paint3_radial_1_56)",
    "fill-opacity": "0.1",
    key: 3,
  }),
  React.createElement("path", {
    d: "M8 2C4.68629 2 2 4.68629 2 8V14C2.00055 14 2.0011 14 2.00165 14C4.15048 13.9991 5.893 12.2604 5.89998 10.1129L5.91297 10.1H5.9V8C5.9 6.8402 6.8402 5.9 8 5.9C8.58583 5.9 9.11564 6.13989 9.49655 6.52679L12.2583 3.77305C11.1713 2.67805 9.66482 2 8 2Z",
    fill: "url(#paint4_linear_1_56)",
    key: 4,
  }),
  React.createElement("path", {
    d: "M8 2C4.68629 2 2 4.68629 2 8V14C2.00055 14 2.0011 14 2.00165 14C4.15048 13.9991 5.893 12.2604 5.89998 10.1129L5.91297 10.1H5.9V8C5.9 6.8402 6.8402 5.9 8 5.9C8.58583 5.9 9.11564 6.13989 9.49655 6.52679L12.2583 3.77305C11.1713 2.67805 9.66482 2 8 2Z",
    fill: "url(#paint5_radial_1_56)",
    key: 5,
  }),
  React.createElement("defs", null, [
    React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_1_56",
        x1: 9.32,
        y1: 6.26,
        x2: 7.34,
        y2: 14.36,
        gradientUnits: "userSpaceOnUse",
        key: 6,
      },
      [
        React.createElement("stop", { stopColor: "#9237E3", key: 7 }),
        React.createElement("stop", {
          offset: 1,
          stopColor: "#48E6F3",
          key: 8,
        }),
      ]
    ),
    React.createElement(
      "linearGradient",
      {
        id: "paint1_linear_1_56",
        x1: 5.9,
        y1: 13.1,
        x2: 11.18,
        y2: 11.9,
        gradientUnits: "userSpaceOnUse",
        key: 9,
      },
      [
        React.createElement("stop", { stopColor: "#51E6FF", key: 10 }),
        React.createElement("stop", {
          offset: 1,
          stopColor: "#71D4FF",
          stopOpacity: 0,
          key: 11,
        }),
      ]
    ),
    React.createElement(
      "radialGradient",
      {
        id: "paint2_radial_1_56",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform:
          "translate(4.1 11.45) rotate(34.5085) scale(2.91247 5.11874)",
        key: 12,
      },
      [
        React.createElement("stop", { key: 13 }),
        React.createElement("stop", {
          offset: 0.699824,
          stopOpacity: 0,
          key: 14,
        }),
      ]
    ),
    React.createElement(
      "radialGradient",
      {
        id: "paint3_radial_1_56",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform:
          "translate(3.38 11) rotate(31.866) scale(5.22793 9.1882)",
        key: 15,
      },
      [
        React.createElement("stop", { offset: 0.328125, key: 16 }),
        React.createElement("stop", {
          offset: 0.604167,
          stopOpacity: 0,
          key: 17,
        }),
      ]
    ),
    React.createElement(
      "linearGradient",
      {
        id: "paint4_linear_1_56",
        x1: 4.46,
        y1: 8.42,
        x2: 7.52,
        y2: 4.1,
        gradientUnits: "userSpaceOnUse",
        key: 18,
      },
      [
        React.createElement("stop", { stopColor: "#6D05E8", key: 19 }),
        React.createElement("stop", {
          offset: 1,
          stopColor: "#AB5ADD",
          stopOpacity: 0,
          key: 20,
        }),
      ]
    ),
    React.createElement(
      "radialGradient",
      {
        id: "paint5_radial_1_56",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform:
          "translate(0.98 5.72) rotate(-9.73945) scale(8.15757 21.4474)",
        key: 21,
      },
      [
        React.createElement("stop", { stopColor: "#6D05E8", key: 22 }),
        React.createElement("stop", {
          offset: 1,
          stopColor: "#6D05E8",
          stopOpacity: 0,
          key: 23,
        }),
      ]
    ),
  ]),
]);

export const WhiteboardRegular = createFluentIconExtended(
  "WhiteboardRegular",
  "16px",
  [
    React.createElement("path", {
      d: "M27.4716 2.8381C26.9341 2.09936 26.2732 1.46351 25.5054 0.946388C25.3683 0.843492 25.201 0.788086 25.0255 0.788086C24.8472 0.788086 24.6717 0.848768 24.5346 0.956942L24.5127 0.972772L24.4935 0.99124L13.7929 11.2862L13.4062 11.6582L13.7929 12.0302L13.9081 12.141L14.0671 11.8297L13.8478 11.616L24.7074 1.16801L24.7183 1.1601C24.8061 1.0915 24.9213 1.05192 25.0364 1.05192C25.1571 1.05192 25.2723 1.09414 25.3628 1.16801C26.0922 1.65611 26.7367 2.27613 27.2577 2.9964C27.4003 3.1547 27.4031 3.4159 27.2495 3.59795L27.2303 3.61906L16.3817 14.0538L16.1595 13.8401L15.8359 13.9931L15.9511 14.1039L16.3378 14.4759L16.7245 14.1039L27.4223 3.81166L27.4415 3.79319L27.4606 3.77208C27.691 3.50033 27.6937 3.11249 27.4716 2.8381Z",
      key: 28,
    }),
    React.createElement("path", {
      d: "M14.1825 11.658L24.8803 1.36572C24.9214 1.33142 24.9735 1.31559 25.0256 1.31559C25.0804 1.31559 25.1326 1.33406 25.1764 1.36836C25.9004 1.85382 26.5284 2.45801 27.033 3.15454C27.1043 3.23633 27.107 3.35769 27.0357 3.43948L16.3379 13.7318C16.3242 13.7449 16.2858 13.7792 16.2255 13.8083L16.1597 13.8399L16.3818 14.0536L27.2304 3.61625L27.2496 3.59515C27.4032 3.4131 27.4005 3.1519 27.2579 2.9936C26.7368 2.27332 26.0924 1.65067 25.3629 1.16521C25.2697 1.09397 25.1545 1.05176 25.0366 1.05176C24.9214 1.05176 24.809 1.09133 24.7185 1.15993L24.7075 1.16785L13.8479 11.6158L14.07 11.8295L14.1029 11.7662C14.1276 11.7134 14.1688 11.6712 14.1825 11.658Z",
      key: 29,
    }),
    React.createElement("path", {
      d: "M16.3379 13.7321C16.3242 13.7453 16.2858 13.7796 16.2254 13.8086L16.1596 13.8402L15.836 13.9933L14.1358 14.7953C13.963 14.8824 13.8478 14.7347 13.8478 14.7347L13.2253 15.0117C13.2253 15.0117 13.058 15.0856 12.9182 14.9484C12.7783 14.8138 12.8524 14.6529 12.8524 14.6529L13.1376 14.0513C13.1376 14.0513 12.9813 13.9405 13.0745 13.7769L13.9082 12.1411L14.0672 11.8298L14.1001 11.7665C14.1276 11.7137 14.1659 11.6715 14.1797 11.6583L21.8362 4.29199H1.23042C0.627106 4.29199 0.13623 4.76426 0.13623 5.3447V22.2355C0.13623 22.816 0.627106 23.2882 1.23042 23.2882H23.7229C24.3262 23.2882 24.8171 22.816 24.8171 22.2355V5.57424L16.3379 13.7321ZM12.5398 15.6423C12.3149 16.2253 11.8405 16.7372 11.2344 17.0696C10.6201 17.3994 9.88793 17.5366 9.15298 17.4363C8.40707 17.3414 7.69407 16.9773 7.19222 16.5208C6.65747 16.0354 5.30825 14.4022 5.06692 14.1305C4.75978 13.8191 4.46361 13.579 4.08792 13.4603C3.31184 13.2229 2.32735 13.3627 1.51013 14.0302C1.51013 14.0302 1.31543 14.1832 1.13992 14.054C0.945215 13.9062 1.03023 13.7215 1.03023 13.7215C1.2551 13.1384 1.72952 12.6266 2.33557 12.2942C2.94985 11.9644 3.68205 11.8272 4.41699 11.9274C5.16291 12.0224 5.87591 12.3865 6.37775 12.8429C6.91251 13.3284 8.26173 14.9616 8.50305 15.2333C8.81019 15.5446 9.10636 15.7847 9.4848 15.9035C10.2609 16.1409 11.2454 16.0011 12.0626 15.3336C12.0626 15.3336 12.2436 15.1647 12.4575 15.3283C12.6248 15.4576 12.5398 15.6423 12.5398 15.6423Z",
      key: 30,
    }),
  ],
  "-2 0 30 24"
);

export const WhiteboardColor = createFluentIconExtended(
  "WhiteboardColor",
  "16px",
  [
    React.createElement("g", { clipPath: "url(#clip0_3984_11044)", key: 0 }, [
      React.createElement("path", {
        d: "M19 2.00464H1C0.447715 2.00464 0 2.45235 0 3.00464V17.0046C0 17.5569 0.447715 18.0046 1 18.0046H19C19.5523 18.0046 20 17.5569 20 17.0046V3.00464C20 2.45235 19.5523 2.00464 19 2.00464Z",
        fill: "url(#paint0_linear_3984_11044)",
        key: 1,
      }),
      React.createElement("path", {
        d: "M11.78 10.1644C11.59 10.0144 11.44 10.1644 11.44 10.1644C10.74 10.7644 9.89004 10.8844 9.22004 10.6744C8.89004 10.5644 8.64004 10.3544 8.37004 10.0744C8.16004 9.83444 7.00004 8.36444 6.54004 7.93444C6.11004 7.52444 5.49004 7.19444 4.85004 7.11444C4.22004 7.02444 3.58004 7.14444 3.06004 7.44444C2.54004 7.74444 2.13004 8.20444 1.93004 8.72444C1.93004 8.72444 1.86004 8.89444 2.02004 9.02444C2.17004 9.14444 2.34004 9.00444 2.34004 9.00444C3.04004 8.40444 3.89004 8.28444 4.56004 8.49444C4.89004 8.60444 5.14004 8.81444 5.41004 9.09444C5.62004 9.33444 6.78004 10.8044 7.24004 11.2344C7.67004 11.6444 8.29004 11.9744 8.93004 12.0544C9.56004 12.1444 10.2 12.0244 10.72 11.7244C11.24 11.4244 11.65 10.9644 11.85 10.4444C11.85 10.4444 11.92 10.2744 11.78 10.1644Z",
        fill: "white",
        key: 2,
      }),
      React.createElement(
        "mask",
        {
          id: "mask0_3984_11044",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "2",
          width: "20",
          height: "17",
          key: 3,
        },
        React.createElement("path", {
          d: "M19 2.00464H1C0.447715 2.00464 0 2.45235 0 3.00464V17.0046C0 17.5569 0.447715 18.0046 1 18.0046H19C19.5523 18.0046 20 17.5569 20 17.0046V3.00464C20 2.45235 19.5523 2.00464 19 2.00464Z",
          fill: "url(#paint1_linear_3984_11044)",
        })
      ),
      React.createElement(
        "g",
        { mask: "url(#mask0_3984_11044)", key: 4 },
        React.createElement(
          "g",
          { filter: "url(#filter0_dd_3984_11044)", key: 5 },
          React.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.73 1.31454L14.13 8.53454H14.14C14.13 8.55454 14.11 8.57454 14.11 8.57454L14.068 8.54782L14.09 8.58447L14.05 8.62447L13.33 9.19447L12.67 9.72447C12.61 9.76447 12.53 9.77447 12.48 9.74447L12.4482 9.7243L12.04 10.0345C11.9 10.1445 11.66 9.99453 11.7 9.81453L11.8078 9.31844L11.77 9.29447C11.71 9.26447 11.69 9.18447 11.71 9.11447L11.91 8.29447L12.13 7.39447C12.13 7.38101 12.1391 7.35848 12.145 7.34519L12.1861 7.3511L12.16 7.33454C12.17 7.32454 12.18 7.29454 12.18 7.29454L16.78 0.0745371C16.82 0.00453712 16.91 -0.0154629 17 0.0245371C17.19 0.0945371 17.52 0.254537 17.89 0.484537C18.26 0.714537 18.53 0.954537 18.68 1.09454C18.75 1.16454 18.77 1.25454 18.73 1.31454ZM12.145 7.34519L12.14 7.34447L12.15 7.33447C12.15 7.33447 12.1479 7.33874 12.145 7.34519Z",
            fill: "#333333",
          })
        )
      ),
      React.createElement("path", {
        d: "M12.79 9.46453L12.04 10.0345C11.9 10.1445 11.66 9.99453 11.7 9.81453L11.9 8.89453L12.79 9.46453Z",
        fill: "#1E2021",
        key: 6,
      }),
      React.createElement("path", {
        d: "M12.15 7.33453C12.15 7.33453 12.13 7.37453 12.13 7.39453L11.91 8.29453L11.71 9.11453C11.69 9.18453 11.71 9.26453 11.77 9.29453L12.48 9.74453C12.53 9.77453 12.61 9.76453 12.67 9.72453L13.33 9.19453L14.05 8.62453C14.05 8.62453 14.08 8.59453 14.09 8.58453L13.46 7.53453L12.14 7.34453L12.15 7.33453Z",
        fill: "#CCCCCC",
        key: 7,
      }),
      React.createElement("path", {
        d: "M14.13 8.53454L18.73 1.31454C18.77 1.25454 18.75 1.16454 18.68 1.09454C18.53 0.954537 18.26 0.714537 17.89 0.484537C17.52 0.254537 17.19 0.0945371 17 0.0245371C16.91 -0.0154629 16.82 0.00453712 16.78 0.0745371L12.18 7.29454C12.18 7.29454 12.17 7.32454 12.16 7.33454L14.11 8.57454C14.11 8.57454 14.13 8.55454 14.14 8.53454H14.13Z",
        fill: "#333333",
        key: 8,
      }),
    ]),
    React.createElement("defs", { key: 9 }, [
      React.createElement(
        "filter",
        {
          id: "filter0_dd_3984_11044",
          x: "10.8622",
          y: "-0.829183",
          width: "8.72154",
          height: "11.7345",
          filterUnits: "userSpaceOnUse",
          colorInterpolationFilters: "sRGB",
          key: 10,
        },
        [
          React.createElement("feFlood", {
            floodOpacity: "0",
            result: "BackgroundImageFix",
            key: 11,
          }),
          React.createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha",
            key: 12,
          }),
          React.createElement("feOffset", { key: 13 }),
          React.createElement("feGaussianBlur", {
            stdDeviation: "0.416667",
            key: 14,
          }),
          React.createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0",
            key: 15,
          }),
          React.createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_3984_11044",
            key: 16,
          }),
          React.createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha",
            key: 17,
          }),
          React.createElement("feOffset", { key: 18 }),
          React.createElement("feGaussianBlur", {
            stdDeviation: "0.0416667",
            key: 19,
          }),
          React.createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0",
            key: 20,
          }),
          React.createElement("feBlend", {
            mode: "normal",
            in2: "effect1_dropShadow_3984_11044",
            result: "effect2_dropShadow_3984_11044",
            key: 21,
          }),
          React.createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect2_dropShadow_3984_11044",
            result: "shape",
            key: 22,
          }),
        ]
      ),
      React.createElement(
        "linearGradient",
        {
          id: "paint0_linear_3984_11044",
          x1: "17.84",
          y1: "23.5846",
          x2: "6.28",
          y2: "3.55464",
          gradientUnits: "userSpaceOnUse",
          key: 23,
        },
        [
          React.createElement("stop", {
            offset: "0.1",
            stopColor: "#30E5D0",
            key: 24,
          }),
          React.createElement("stop", {
            offset: "1",
            stopColor: "#0C34FB",
            key: 25,
          }),
        ]
      ),
      React.createElement(
        "linearGradient",
        {
          id: "paint1_linear_3984_11044",
          x1: "17.84",
          y1: "23.5846",
          x2: "6.28",
          y2: "3.55464",
          gradientUnits: "userSpaceOnUse",
          key: 26,
        },
        [
          React.createElement("stop", {
            offset: "0.1",
            stopColor: "#30E5D0",
            key: 27,
          }),
          React.createElement("stop", {
            offset: "1",
            stopColor: "#0C34FB",
            key: 28,
          }),
        ]
      ),
      React.createElement(
        "clipPath",
        { id: "clip0_3984_11044", key: 29 },
        React.createElement("rect", {
          width: "20",
          height: "20",
          fill: "white",
        })
      ),
    ]),
  ],
  "0 0 20 20"
);

export const VivaTopicsRegular = createFluentIcon("VivaTopicsRegular", "16px", [
  "M9.04654 13.2714C9.25159 13.0093 9.42821 12.724 9.57178 12.4199C9.84826 12.6034 10.1521 12.7484 10.4757 12.8475C10.7997 12.9467 11.1436 13 11.5 13C13.4331 13 15 11.4336 15 9.5C15 7.72656 13.6802 6.25977 11.9688 6.03125C11.9814 5.92383 11.9902 5.81641 11.9951 5.70508L12 5.5C12 3.01562 9.98535 1 7.5 1C5.01465 1 3 3.01562 3 5.5C3 5.69922 3.0127 5.89453 3.0376 6.08594C3.06299 6.28125 3.10156 6.47461 3.15186 6.66211C1.86035 7.45312 1 8.87695 1 10.5C1 12.9863 3.01465 15 5.5 15C6.94065 15 8.22291 14.3239 9.04654 13.2714ZM11 5.48883L10.9957 5.67065C10.9918 5.75379 10.9851 5.83368 10.9757 5.91389L10.9298 6.30217L8.87714 8.41253L4.14566 6.50722L4.11771 6.40304C4.07876 6.25781 4.04887 6.10792 4.02925 5.95702C4.00999 5.80893 4 5.65662 4 5.5C4 3.56777 5.56707 2 7.5 2C9.4292 2 10.994 3.56173 11 5.48883ZM3.79186 7.44278L8.54562 9.35707L8.8656 11.5734L8.6675 11.993C8.10642 13.1813 6.89842 14 5.5 14C3.56679 14 2 12.4339 2 10.5C2 9.23907 2.66719 8.13161 3.67415 7.51487L3.79186 7.44278ZM9.52981 9.17574L11.6486 6.99738L11.8364 7.02245C13.0573 7.18547 14 8.23391 14 9.5C14 10.8812 12.8809 12 11.5 12C10.9899 12 10.5188 11.8483 10.1248 11.5867L9.85173 11.4055L9.52981 9.17574Z",
]);

export const VivaTopicsColor = createFluentIconExtended(
  "VivaTopicsColor",
  "16px",
  [
    React.createElement("circle", {
      cx: "7.5",
      cy: "5.5",
      r: "4.5",
      fill: "#B26BFF",
      key: 0,
    }),
    React.createElement("path", {
      d: "M11.9687 6.03113L9 8.99953L9.57222 12.4217C10.125 12.7872 10.7877 13 11.5 13C13.433 13 15 11.433 15 9.50001C15 7.72596 13.6801 6.26019 11.9687 6.03113Z",
      fill: "#7655AE",
      key: 1,
    }),
    React.createElement("path", {
      d: "M3.15045 6.66132L9 8.99997L9.57184 12.4182C8.85174 13.9441 7.29917 15 5.5 15C3.01472 15 1 12.9853 1 10.5C1 8.87578 1.86049 7.45256 3.15045 6.66132Z",
      fill: "#3C2B5E",
      key: 2,
    }),
  ]
);

export const OfficeFormsRegular = createFluentIcon(
  "OfficeFormsRegular",
  "16px",
  [
    "M 15 0 q 0.2031 0 0.3828 0.0781 t 0.3203 0.2109 t 0.2188 0.3203 t 0.0781 0.3906 v 14 q 0 0.2109 -0.0781 0.3906 t -0.2109 0.3125 t -0.3203 0.2188 t -0.3906 0.0781 H 4 q -0.2031 0 -0.3828 -0.0781 t -0.3203 -0.2109 t -0.2188 -0.3203 t -0.0781 -0.3906 v -2 H 1 q -0.2031 0 -0.3828 -0.0781 t -0.3203 -0.2109 t -0.2188 -0.3203 t -0.0781 -0.3906 V 4 q 0 -0.2031 0.0781 -0.3828 t 0.2109 -0.3203 t 0.3203 -0.2188 t 0.3906 -0.0781 h 2 V 1 q 0 -0.2109 0.0781 -0.3906 t 0.2109 -0.3125 t 0.3203 -0.2188 t 0.3906 -0.0781 h 11 z M 4 1 v 2 h 5 q 0.1094 0 0.2188 0.0234 t 0.2109 0.0703 q 0.3516 -0.5156 0.8984 -0.8047 t 1.1719 -0.2891 q 0.5156 0 0.9688 0.1953 t 0.7969 0.5313 t 0.5391 0.7969 t 0.1953 0.9766 q 0 0.5156 -0.1953 0.9688 t -0.5313 0.7969 t -0.7969 0.5391 t -0.9766 0.1953 q -0.4063 0 -0.7891 -0.125 t -0.7109 -0.375 v 1.5 h 5 V 1 H 4 z m 7.5 2 q -0.3125 0 -0.5859 0.1172 t -0.4766 0.3203 t -0.3203 0.4766 t -0.1172 0.5859 q 0 0.3125 0.1172 0.5859 t 0.3203 0.4766 t 0.4766 0.3203 t 0.5859 0.1172 q 0.3125 0 0.5859 -0.1172 t 0.4766 -0.3203 t 0.3203 -0.4766 t 0.1172 -0.5859 q 0 -0.3125 -0.1172 -0.5859 t -0.3203 -0.4766 t -0.4766 -0.3203 t -0.5859 -0.1172 z M 3.0625 11.25 h 1.6797 v -2.4219 h 2.4219 V 7.3594 H 4.7422 V 6.2266 h 2.5938 V 4.75 H 3.0625 v 6.5 z m 0.9375 3.75 h 11 v -6 h -5 v 1 h 4 v 4 h -4 v -2 q 0 0.2031 -0.0781 0.3828 t -0.2109 0.3203 t -0.3203 0.2188 t -0.3906 0.0781 H 4 v 2 z m 7 -2 h 2 v -2 h -2 v 2 z",
  ]
);

export const OfficeFormsColor = createFluentIconExtended(
  "OfficeFormsColor",
  "16px",
  [
    React.createElement("path", {
      d: "M3 8V15C3 15.5 3.5 16 4 16H15C15.6 16 16 15.6 16 15V8L10 6L3 8Z",
      fill: "#036C70",
      key: 0,
    }),
    React.createElement("path", {
      d: "M16 8V1C16 0.4 15.6 0 15 0H4C3.4 0 3 0.4 3 1V8H16Z",
      fill: "#37C6D0",
      key: 1,
    }),
    React.createElement("path", {
      d: "M14 10H10V14H14V10Z",
      fill: "#1A9BA1",
      key: 2,
    }),
    React.createElement("path", {
      d: "M12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7Z",
      fill: "#1A9BA1",
      key: 3,
    }),
    React.createElement("path", {
      d: "M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z",
      fill: "#036C70",
      key: 4,
    }),
    React.createElement("path", {
      d: "M10 4H3V14H9C10.1 14 11 13.1 11 12V5C11 4.5 10.6 4 10 4Z",
      fill: "black",
      opacity: 0.5,
      key: 5,
    }),
    React.createElement("path", {
      d: "M9 13H1C0.4 13 0 12.6 0 12V4C0 3.5 0.4 3 1 3H9C9.6 3 10 3.5 10 4V12C10 12.6 9.6 13 9 13Z",
      fill: "#038387",
      key: 6,
    }),
    React.createElement("path", {
      d: "M7.10005 6H4.50005V7.6H6.90005V8.6H4.50005V11H3.30005V5H7.10005V6Z",
      fill: "white",
      key: 7,
    }),
  ]
);

export const OfficePlannerRegular = createFluentIcon(
  "OfficePlannerRegular",
  "16px",
  [
    "M12.2021 1.49497C11.5382 0.831081 10.4618 0.831083 9.79793 1.49497L7.00001 4.29289L6.2021 3.49497C5.5382 2.83108 4.46183 2.83108 3.79793 3.49497L1.49499 5.79792C0.831097 6.46181 0.831097 7.53819 1.49499 8.20208L7.79793 14.505C8.46183 15.1689 9.53821 15.1689 10.2021 14.505L14.505 10.2021C15.1689 9.53819 15.1689 8.46181 14.505 7.79792L13.7071 7L14.505 6.20208C15.1689 5.53819 15.1689 4.46181 14.505 3.79792L12.2021 1.49497ZM8.50504 13.7979L5.60081 10.8937C5.82005 10.811 6.02564 10.6815 6.2021 10.505L10.505 6.20208C10.7784 5.92871 11.2216 5.92871 11.495 6.20208L13.7979 8.50502C14.0713 8.77839 14.0713 9.22161 13.7979 9.49497L9.49499 13.7979C9.22162 14.0713 8.77841 14.0713 8.50504 13.7979ZM3.49499 7.79792C3.22171 8.0712 2.77868 8.07129 2.50529 7.79817L2.2021 7.49497C1.92873 7.22161 1.92873 6.77839 2.2021 6.50502L4.50504 4.20208C4.77841 3.92871 5.22162 3.92871 5.49499 4.20208L6.29291 5L3.49499 7.79792ZM7.35357 5.35355L10.505 2.20208C10.7784 1.92871 11.2216 1.92871 11.495 2.20208L13.7979 4.50502C14.0713 4.77839 14.0713 5.22161 13.7979 5.49497L13 6.29289L12.2021 5.49497C11.5382 4.83108 10.4618 4.83108 9.79793 5.49497L5.49499 9.79792C5.22172 10.0712 4.77843 10.071 4.50504 9.79792L3.60081 8.89369C3.82005 8.81103 4.02564 8.68148 4.20209 8.50503L7.35357 5.35355Z",
  ]
);

export const OfficePlannerColor = createFluentIconExtended(
  "OfficePlannerColor",
  "16px",
  [
    React.createElement("path", {
      d: "M5.81731 10.1825C5.21459 10.7852 4.23739 10.7852 3.63468 10.1825L1.45204 7.99991C0.849321 7.3972 0.84932 6.42001 1.45204 5.8173L3.63467 3.6347C4.23739 3.03199 5.21459 3.03199 5.81731 3.6347L7.99995 5.8173C8.60267 6.42001 8.60267 7.3972 7.99995 7.99991L5.81731 10.1825Z",
      fill: "url(#paint0_linear_61942_8548)",
      key: 0,
    }),
    React.createElement("path", {
      d: "M5.81731 10.1825C5.21459 10.7852 4.23739 10.7852 3.63468 10.1825L1.45204 7.99991C0.849321 7.3972 0.84932 6.42001 1.45204 5.8173L3.63467 3.6347C4.23739 3.03199 5.21459 3.03199 5.81731 3.6347L7.99995 5.8173C8.60267 6.42001 8.60267 7.3972 7.99995 7.99991L5.81731 10.1825Z",
      fill: "url(#paint1_linear_61942_8548)",
      key: 1,
    }),
    React.createElement("path", {
      d: "M1.45215 8.00008C2.05488 8.6028 3.03211 8.6028 3.63484 8.00007L10.183 1.45205C10.7857 0.84932 11.7629 0.849317 12.3656 1.45204L14.5483 3.6347C15.1511 4.23743 15.1511 5.21464 14.5483 5.81737L8.00022 12.3654C7.39749 12.9681 6.42026 12.9681 5.81753 12.3654L1.45215 8.00008Z",
      fill: "url(#paint2_linear_61942_8548)",
      key: 2,
    }),
    React.createElement("path", {
      d: "M1.45215 8.00008C2.05488 8.6028 3.03211 8.6028 3.63484 8.00007L10.183 1.45205C10.7857 0.84932 11.7629 0.849317 12.3656 1.45204L14.5483 3.6347C15.1511 4.23743 15.1511 5.21464 14.5483 5.81737L8.00022 12.3654C7.39749 12.9681 6.42026 12.9681 5.81753 12.3654L1.45215 8.00008Z",
      fill: "url(#paint3_linear_61942_8548)",
      key: 3,
    }),
    React.createElement("path", {
      d: "M3.63477 10.1826C4.2375 10.7854 5.21473 10.7854 5.81746 10.1826L10.1829 5.81728C10.7856 5.21455 11.7628 5.21455 12.3656 5.81728L14.5483 7.99995C15.151 8.60267 15.151 9.57989 14.5483 10.1826L10.1829 14.548C9.58012 15.1507 8.60289 15.1507 8.00016 14.548L3.63477 10.1826Z",
      fill: "url(#paint4_linear_61942_8548)",
      key: 4,
    }),
    React.createElement("path", {
      d: "M3.63477 10.1826C4.2375 10.7854 5.21473 10.7854 5.81746 10.1826L10.1829 5.81728C10.7856 5.21455 11.7628 5.21455 12.3656 5.81728L14.5483 7.99995C15.151 8.60267 15.151 9.57989 14.5483 10.1826L10.1829 14.548C9.58012 15.1507 8.60289 15.1507 8.00016 14.548L3.63477 10.1826Z",
      fill: "url(#paint5_linear_61942_8548)",
      key: 5,
    }),
    React.createElement(
      "defs",
      {
        key: 6,
      },
      [
        React.createElement(
          "linearGradient",
          {
            id: "paint0_linear_61942_8548",
            x1: "4.72596",
            y1: "3.18267",
            x2: "2.25874",
            y2: "8.45339",
            gradientUnits: "userSpaceOnUse",
            key: 7,
          },
          [
            React.createElement("stop", {
              "stop-color": "#8752E0",
              key: 8,
            }),
            React.createElement("stop", {
              offset: "1",
              "stop-color": "#541278",
              key: 9,
            }),
          ]
        ),
        React.createElement(
          "linearGradient",
          {
            id: "paint1_linear_61942_8548",
            x1: "5.88861",
            y1: "7.45738",
            x2: "3.88208",
            y2: "5.48733",
            gradientUnits: "userSpaceOnUse",
            key: 10,
          },
          [
            React.createElement("stop", {
              offset: "0.12172",
              "stop-color": "#3D0D59",
              key: 11,
            }),
            React.createElement("stop", {
              offset: "1",
              "stop-color": "#7034B0",
              "stop-opacity": "0",
              key: 12,
            }),
          ]
        ),
        React.createElement(
          "linearGradient",
          {
            id: "paint2_linear_61942_8548",
            x1: "11.7162",
            y1: "0.999981",
            x2: "6.75026",
            y2: "12.9114",
            gradientUnits: "userSpaceOnUse",
            key: 13,
          },
          [
            React.createElement("stop", {
              "stop-color": "#DB45E0",
              key: 14,
            }),
            React.createElement("stop", {
              offset: "1",
              "stop-color": "#6C0F71",
              key: 15,
            }),
          ]
        ),
        React.createElement(
          "linearGradient",
          {
            id: "paint3_linear_61942_8548",
            x1: "11.7162",
            y1: "0.999981",
            x2: "6.75026",
            y2: "12.9114",
            gradientUnits: "userSpaceOnUse",
            key: 16,
          },
          [
            React.createElement("stop", {
              "stop-color": "#DB45E0",
              key: 17,
            }),
            React.createElement("stop", {
              offset: "0.677403",
              "stop-color": "#A829AE",
              key: 18,
            }),
            React.createElement("stop", {
              offset: "1",
              "stop-color": "#8F28B3",
              key: 19,
            }),
          ]
        ),
        React.createElement(
          "linearGradient",
          {
            id: "paint4_linear_61942_8548",
            x1: "11.5005",
            y1: "5.37484",
            x2: "9.16719",
            y2: "14.9996",
            gradientUnits: "userSpaceOnUse",
            key: 20,
          },
          [
            React.createElement("stop", {
              "stop-color": "#3DCBFF",
              key: 21,
            }),
            React.createElement("stop", {
              offset: "1",
              "stop-color": "#00479E",
              key: 22,
            }),
          ]
        ),
        React.createElement(
          "linearGradient",
          {
            id: "paint5_linear_61942_8548",
            x1: "11.6265",
            y1: "5.62375",
            x2: "7.13909",
            y2: "14.3798",
            gradientUnits: "userSpaceOnUse",
            key: 23,
          },
          [
            React.createElement("stop", {
              "stop-color": "#3DCBFF",
              key: 24,
            }),
            React.createElement("stop", {
              offset: "1",
              "stop-color": "#4A40D4",
              key: 25,
            }),
          ]
        ),
      ]
    ),
  ]
);

export const StreamRegular = createFluentIcon("StreamRegular", "16px", [
  "M7.30673 2.24035L14.3083 6.73746C15.2275 7.32783 15.2275 8.67127 14.3083 9.26164L7.30673 13.7587C6.30843 14.3999 4.99609 13.6831 4.99609 12.4966V10.9651L4.02125 11.7294C3.20089 12.3726 2 11.7881 2 10.7457V5.2523C2 4.20986 3.20089 3.62541 4.02125 4.26859L4.99609 5.0329V3.50244C4.99609 2.31596 6.30843 1.59914 7.30673 2.24035ZM5.99609 5.81693L7.52456 7.01529C8.16289 7.51576 8.16289 8.48223 7.52456 8.9827L5.99609 10.1811V12.4966C5.99609 12.8921 6.43354 13.1311 6.76631 12.9173L13.7679 8.42024C14.0743 8.22345 14.0743 7.77564 13.7679 7.57885L6.76631 3.08174C6.43354 2.86801 5.99609 3.10694 5.99609 3.50244V5.81693ZM3 5.2523V10.7457C3 10.9542 3.24018 11.0711 3.40425 10.9424L6.90756 8.19574C7.03523 8.09564 7.03523 7.90235 6.90756 7.80225L3.40425 5.05556C3.24018 4.92692 3 5.04381 3 5.2523Z",
]);

export const StreamColor = createFluentIconExtended("StreamColor", "16px", [
  React.createElement("path", {
    d: "M4.6543 8.00012V12.7655C4.6543 13.7431 5.79776 14.3315 6.66292 13.7992L14.4075 9.03361C14.8023 8.79069 14.9997 8.39542 14.9998 8.00012L10 7L4.6543 8.00012Z",
    fill: "url(#paint0_linear_53046_136094)",
    key: 0,
  }),
  React.createElement("path", {
    d: "M6.65809 2.19785C5.79351 1.67063 4.6543 2.2587 4.6543 3.23448V8.00005H14.9998C14.9998 7.60626 14.8039 7.21247 14.4122 6.96927C14.4106 6.9683 14.4091 6.96733 14.4075 6.96636L6.66292 2.20081C6.66131 2.19982 6.6597 2.19883 6.65809 2.19785Z",
    fill: "url(#paint1_linear_53046_136094)",
    key: 1,
  }),
  React.createElement(
    "mask",
    {
      id: "mask0_53046_136094",
      maskUnits: "userSpaceOnUse",
      x: "4",
      y: "2",
      width: "12",
      height: "12",
      key: 2,
    },
    React.createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.65527 3.23448C4.65527 2.2587 5.79449 1.67063 6.65906 2.19785L6.66389 2.20081L14.4085 6.96636L14.4132 6.96927C14.8049 7.21247 15.0007 7.60626 15.0007 8.00005H4.65527V3.23448ZM4.65527 12.7655V8.00009H15.0007C15.0007 8.39538 14.8033 8.79065 14.4085 9.03358L6.66389 13.7991C5.79874 14.3315 4.65527 13.743 4.65527 12.7655Z",
      fill: "url(#paint2_linear_53046_136094)",
      key: 3,
    })
  ),
  React.createElement(
    "g",
    {
      mask: "url(#mask0_53046_136094)",
      key: 4,
    },
    React.createElement(
      "g",
      {
        filter: "url(#filter0_dd_53046_136094)",
        key: 5,
      },
      React.createElement("path", {
        d: "M1.99902 5.14306C1.99902 4.64639 2.58723 4.35378 3.01856 4.63588L7.3871 7.49303C7.76164 7.73799 7.76164 8.26242 7.3871 8.50738L3.01856 11.3645C2.58723 11.6466 1.99902 11.354 1.99902 10.8574V5.14306Z",
        fill: "url(#paint3_linear_53046_136094)",
        key: 6,
      })
    )
  ),
  React.createElement("path", {
    d: "M2 5.14292C2 4.64625 2.58821 4.35364 3.01954 4.63574L7.38808 7.49289C7.76262 7.73785 7.76262 8.26228 7.38808 8.50724L3.01954 11.3644C2.58821 11.6465 2 11.3539 2 10.8572V5.14292Z",
    fill: "url(#paint4_linear_53046_136094)",
    key: 7,
  }),
  React.createElement(
    "defs",
    null,
    React.createElement(
      "filter",
      {
        id: "filter0_dd_53046_136094",
        x: "1.70522",
        y: "4.23197",
        width: "6.84414",
        height: "8.12406",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB",
        key: 8,
      },
      [
        React.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix",
          key: 9,
        }),
        React.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha",
          key: 10,
        }),
        React.createElement("feOffset", {
          dx: "0.293799",
          dy: "0.293799",
          key: 11,
        }),
        React.createElement("feGaussianBlur", {
          stdDeviation: "0.293799",
          key: 12,
        }),
        React.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0",
          key: 13,
        }),
        React.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_53046_136094",
          key: 14,
        }),
        React.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha",
          key: 15,
        }),
        React.createElement("feOffset", {
          dy: "0.0587598",
          key: 16,
        }),
        React.createElement("feGaussianBlur", {
          stdDeviation: "0.0293799",
          key: 17,
        }),
        React.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0",
          key: 18,
        }),
        React.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow_53046_136094",
          result: "effect2_dropShadow_53046_136094",
          key: 19,
        }),
        React.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow_53046_136094",
          result: "shape",
          key: 20,
        }),
      ]
    ),
    React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_53046_136094",
        x1: "4.65425",
        y1: "7.9864",
        x2: "5.15477",
        y2: "13.9631",
        gradientUnits: "userSpaceOnUse",
        key: 21,
      },
      [
        React.createElement("stop", {
          offset: "0.0961728",
          "stop-color": "#BD3177",
          key: 22,
        }),
        React.createElement("stop", {
          offset: "0.990776",
          "stop-color": "#832054",
          key: 23,
        }),
      ]
    ),
    React.createElement(
      "linearGradient",
      {
        id: "paint1_linear_53046_136094",
        x1: "4.65425",
        y1: "1.98628",
        x2: "5.15916",
        y2: "7.93889",
        gradientUnits: "userSpaceOnUse",
        key: 24,
      },
      [
        React.createElement("stop", {
          offset: "0.0961728",
          "stop-color": "#F992CA",
          key: 25,
        }),
        React.createElement("stop", {
          offset: "0.990776",
          "stop-color": "#DA3988",
          key: 26,
        }),
      ]
    ),
    React.createElement(
      "linearGradient",
      {
        id: "paint2_linear_53046_136094",
        x1: "4.65522",
        y1: "1.98628",
        x2: "5.16014",
        y2: "7.9389",
        gradientUnits: "userSpaceOnUse",
        key: 27,
      },
      [
        React.createElement("stop", {
          offset: "0.0961728",
          "stop-color": "#FF98E8",
          key: 28,
        }),
        React.createElement("stop", {
          offset: "0.990776",
          "stop-color": "#E11275",
          key: 29,
        }),
      ]
    ),
    React.createElement(
      "linearGradient",
      {
        id: "paint3_linear_53046_136094",
        x1: "4.83352",
        y1: "4.52577",
        x2: "4.83352",
        y2: "11.4746",
        gradientUnits: "userSpaceOnUse",
        key: 30,
      },
      [
        React.createElement("stop", {
          "stop-color": "#9D73CB",
          key: 31,
        }),
        React.createElement("stop", {
          offset: "0.488577",
          "stop-color": "#BC1948",
          key: 32,
        }),
        React.createElement("stop", {
          offset: "1",
          "stop-color": "#EE6F99",
          key: 33,
        }),
      ]
    ),
    React.createElement(
      "linearGradient",
      {
        id: "paint4_linear_53046_136094",
        x1: "1.99997",
        y1: "4.50975",
        x2: "3.206",
        y2: "11.2371",
        gradientUnits: "userSpaceOnUse",
        key: 34,
      },
      [
        React.createElement("stop", {
          offset: "0.0961728",
          "stop-color": "#F992CA",
          key: 35,
        }),
        React.createElement("stop", {
          offset: "0.990776",
          "stop-color": "#DA3988",
          key: 36,
        }),
      ]
    )
  ),
]);

export const VivaEngageRegular = createFluentIcon("VivaEngageRegular", "16px", [
  "M1 4.5C1 2.56689 2.56702 1 4.5 1C5.90096 1 7.10965 1.82294 7.6689 3.012C7.77823 3.00405 7.88864 3 8 3C8.11135 3 8.22176 3.00405 8.33109 3.012C8.89031 1.82299 10.099 1 11.5 1C13.433 1 15 2.56689 15 4.5V9.96875C15 11.5637 14.3438 15 10.8438 15H10.75C9.66346 15 8.68489 14.5687 8.00002 13.8796C7.31514 14.5687 6.33653 15 5.25 15H5.15625C1.65625 15 1 11.5637 1 9.96875V4.5ZM6.6411 3.20882C6.20327 2.48442 5.40822 2 4.5 2C3.11926 2 2 3.11938 2 4.5V6.08107C2.36802 6.7018 2.85799 7.23664 3.50074 7.58245C3.50025 7.55503 3.5 7.52754 3.5 7.5C3.5 5.48834 4.82 3.78498 6.6411 3.20882ZM4.52708 7.93749C4.75411 7.97838 4.99484 8 5.25 8C6.3365 8 7.31509 8.43131 7.99997 9.12046C8.68484 8.43125 9.66345 8 10.75 8C11.0052 8 11.2459 7.97838 11.4729 7.93749C11.4908 7.79417 11.5 7.64816 11.5 7.5C11.5 5.567 9.933 4 8 4C6.067 4 4.5 5.567 4.5 7.5C4.5 7.64816 4.50921 7.79417 4.52708 7.93749ZM12.4993 7.58246C13.142 7.23664 13.6316 6.70252 13.9996 6.08179L14 4.5C14 3.11938 12.8807 2 11.5 2C10.5918 2 9.79669 2.48441 9.35886 3.20881C11.18 3.78495 12.5 5.48832 12.5 7.5C12.5 7.52754 12.4997 7.55503 12.4993 7.58246ZM8.60614 13.0632C9.09935 13.6254 9.85822 14 10.75 14H10.8438C12.1848 14 12.9153 13.3794 13.365 12.5884C13.8507 11.7339 14 10.6667 14 9.96899L13.9998 7.70093C13.2181 8.47021 12.1536 9 10.75 9C9.8582 9 9.0993 9.3746 8.6061 9.93684C8.85817 10.4073 9 10.9382 9 11.5C9 12.0618 8.85818 12.5927 8.60614 13.0632ZM5.15643 14H5.25C6.8349 14 8 12.8169 8 11.5C8 10.1831 6.8349 9 5.25 9C3.84644 9 2.78186 8.47021 2.00024 7.70093L2 9.96875C2 10.6667 2.14929 11.7339 2.63501 12.5884C3.08466 13.3794 3.81543 14 5.15643 14Z",
]);

export const VivaEngageColor = createFluentIconExtended(
  "VivaEngageColor",
  "16px",
  [
    React.createElement("path", {
      d: "M4.5 1C6.43299 1 8 2.567 8 4.5L8 9H1V4.5C1 2.567 2.567 1 4.5 1Z",
      fill: "#0472D8",
      key: 0,
    }),
    React.createElement("path", {
      d: "M11.5 1C9.56701 1 8 2.567 8 4.5L8 9H15V4.5C15 2.567 13.433 1 11.5 1Z",
      fill: "#2596FF",
      key: 1,
    }),
    React.createElement("path", {
      d: "M11.5 7.5C11.5 5.567 9.933 4 8 4C6.067 4 4.5 5.567 4.5 7.5C4.5 9.433 6.067 11 8 11C9.933 11 11.5 9.433 11.5 7.5Z",
      fill: "#56C5FF",
      key: 2,
    }),
    React.createElement("path", {
      d: "M14.997 4.35254C14.9089 6.49185 12.9753 7.99979 10.75 7.99979C8.67893 7.99979 7 9.56679 7 11.4998C7 13.4328 8.67893 14.9998 10.75 14.9998C10.759 14.9998 10.8438 14.9998 10.8438 14.9998C14.3438 14.9998 15 11.5636 15 9.96854L14.9992 4.42549C14.9987 4.40111 14.998 4.37679 14.997 4.35254Z",
      fill: "#0472D8",
      key: 3,
    }),
    React.createElement("path", {
      d: "M1.00077 4.4255C1.00128 4.40112 1.00204 4.3768 1.00304 4.35254C1.09108 6.49185 3.02471 7.99979 5.25 7.99979C7.32107 7.99979 9 9.56679 9 11.4998C9 13.4328 7.32107 14.9998 5.25 14.9998C5.24098 14.9998 5.15625 14.9998 5.15625 14.9998C1.65625 14.9998 1 11.5636 1 9.96854L1.00077 4.4255Z",
      fill: "#0C4497",
      key: 4,
    }),
  ]
);

export const VivaGoalsRegular = createFluentIcon("VivaGoalsRegular", "16px", [
  "M6.15064 5.90845C6.62574 4.22998 8.16944 3 10 3C10.1113 3 10.2214 3.00464 10.3303 3.01343C10.8892 1.82373 12.0984 1 13.5 1H14.5L14.5156 1.00024C14.7832 1.00854 14.9978 1.22705 15 1.49609V8C15 11.7339 12.0774 14.7849 8.39454 14.989C8.26417 14.9963 8.13209 15 8.00001 15C5.5691 15 3.4275 13.7607 2.17261 11.8799C1.43189 10.7693 1 9.43506 1 8C1 7.95748 0.999515 8 1.00831 7.77539C1.1233 6.22363 2.41895 5 4 5C4.84327 5 5.60547 5.34814 6.15064 5.90845ZM5.50001 12C7.94605 12 9.93628 10.0483 9.99854 7.61743L10 6.61743V4.5C10 4.33032 10.012 4.16357 10.0354 4.00024C10.0237 4.00024 10.0117 4 10 4C8.35767 4 7.0232 5.32007 7.00001 6.95654V8C7.00001 9.65674 5.65674 11 4 11C3.50391 11 3.03565 10.8794 2.6233 10.666C2.66895 10.7578 2.7168 10.8481 2.76685 10.937C2.81348 11.02 2.86207 11.1016 2.91236 11.1821C3.64429 11.6973 4.53687 12 5.50001 12ZM6.00001 8C6.00001 6.89551 5.1045 6 4 6C2.89551 6 2 6.89551 2 8C2 9.10449 2.89551 10 4 10C5.1045 10 6.00001 9.10449 6.00001 8ZM8.00001 14H8.03028C8.13282 13.9995 8.23462 13.9963 8.3357 13.9907C11.4932 13.8167 14 11.2012 14 8V2H13.5C12.1194 2 11 3.11938 11 4.5V6.6189L10.9985 7.63086L10.9983 7.64307C10.9221 10.6147 8.48975 13 5.50001 13C5.18189 13 4.86988 12.9729 4.56641 12.9211C5.53931 13.6011 6.72315 14 8.00001 14Z",
]);

export const VivaGoalsColor = createFluentIconExtended(
  "VivaGoalsColor",
  "16px",
  [
    React.createElement("path", {
      d: "M6.99971 6.9501C7.02364 4.9989 8.44489 3.38404 10.309 3.05957C10.1103 3.49892 9.99971 3.98662 9.99971 4.50015V7.61752H9.99821C9.93597 10.0486 7.94575 12.0002 5.49971 12.0002C3.9277 12.0002 2.54395 11.1941 1.73926 9.9727C2.2892 10.6024 3.098 11.0002 3.99971 11.0002C5.61777 11.0002 6.93663 9.71927 6.99751 8.11612C6.99897 8.07768 6.99971 8.03905 6.99971 8.00024V6.9501Z",
      fill: "#068576",
      key: 0,
    }),
    React.createElement("path", {
      d: "M14.5157 1.00024C14.7832 1.00848 14.9979 1.22694 15 1.496L15 1.5V8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 8.75501 1.2789 9.44487 1.7393 9.97218C2.54396 11.1938 3.92783 12 5.5 12C7.94604 12 9.93626 10.0484 9.9985 7.61737H10V4.5C10 2.567 11.567 1 13.5 1L13.5208 1.00006L14.5 1L14.5157 1.00024Z",
      fill: "#00554C",
      key: 1,
    }),
    React.createElement("path", {
      d: "M7 8C7 9.65685 5.65685 11 4 11C2.34315 11 1 9.65685 1 8C1 6.34315 2.34315 5 4 5C5.65685 5 7 6.34315 7 8Z",
      fill: "#40DCC9",
      key: 2,
    }),
  ]
);

export const AzureBlack = createFluentIconExtended("AzureRegular", "16px", [
  React.createElement("path", {
    d: "M 5.667969 1 L 10.355469 1 C 10.785156 1 11.164062 1.273438 11.300781 1.679688 L 15.351562 13.679688 C 15.570312 14.328125 15.089844 15 14.40625 15 L 9.832031 15 L 9.832031 14.996094 C 9.800781 15 9.769531 15 9.738281 15 L 9.71875 15 C 9.507812 15 9.296875 14.929688 9.125 14.804688 L 6.070312 12.535156 L 5.46875 14.320312 C 5.332031 14.726562 4.949219 15 4.519531 15 L 1.59375 15 C 0.910156 15 0.429688 14.328125 0.648438 13.679688 L 4.699219 1.679688 C 4.835938 1.273438 5.214844 1 5.644531 1 Z M 3.878906 10.074219 L 9.523438 14.269531 C 9.578125 14.308594 9.648438 14.332031 9.71875 14.332031 L 9.738281 14.332031 C 9.964844 14.332031 10.128906 14.109375 10.054688 13.894531 L 7.816406 7.265625 L 6.867188 9.792969 L 6.785156 10.007812 L 3.789062 10.007812 Z M 14.40625 14.332031 L 10.679688 14.332031 C 10.753906 14.132812 10.761719 13.90625 10.6875 13.679688 L 6.636719 1.679688 C 6.632812 1.675781 6.632812 1.671875 6.632812 1.667969 L 10.355469 1.667969 C 10.496094 1.667969 10.625 1.757812 10.671875 1.894531 L 14.71875 13.894531 C 14.792969 14.109375 14.632812 14.332031 14.40625 14.332031 Z M 14.40625 14.332031",
    fill: "black",
    fillRule: "evenodd",
    clipRule: "evenodd",
    key: 0,
  }),
]);

export const AzureColor = createFluentIconExtended(
  "AzureColor",
  "16px",
  [
    React.createElement("path", {
      d: "M5.33492 1.37491C5.44717 1.04229 5.75909 0.818359 6.11014 0.818359H11.25L5.91513 16.6255C5.80287 16.9581 5.49095 17.182 5.13991 17.182H1.13968C0.579936 17.182 0.185466 16.6325 0.364461 16.1022L5.33492 1.37491Z",
      fill: "url(#paint0_linear_6102_134469)",
      key: 0,
    }),
    React.createElement("path", {
      d: "M13.5517 11.4546H5.45126C5.1109 11.4546 4.94657 11.8715 5.19539 12.1037L10.4005 16.9618C10.552 17.1032 10.7515 17.1819 10.9587 17.1819H15.5453L13.5517 11.4546Z",
      fill: "#0078D4",
      key: 1,
    }),
    React.createElement("path", {
      d: "M 6.11014 0.818359 C 5.75909 0.818359 5.44717 1.04229 5.33492 1.37491 L 0.364461 16.1022 C 0.185466 16.6325 0.579936 17.182 1.13968 17.182 H 5.13991 C 5.49095 17.182 5.80287 16.9581 5.91513 16.6255 L 6.90327 13.6976 L 10.4005 16.9617 C 10.552 17.1032 10.7515 17.1818 10.9588 17.1818 H 15.5454 L 13.5517 11.4545 H 7.66032 L 11.25 0.818359 H 6.11014 Z",
      fill: "url(#paint1_linear_6102_134469)",
      key: 2,
    }),
    React.createElement("path", {
      d: "M12.665 1.37478C12.5528 1.04217 12.2409 0.818237 11.8898 0.818237H6.13629H6.16254C6.51358 0.818237 6.82551 1.04217 6.93776 1.37478L11.9082 16.1021C12.0872 16.6324 11.6927 17.1819 11.133 17.1819H11.0454H16.8603C17.42 17.1819 17.8145 16.6324 17.6355 16.1021L12.665 1.37478Z",
      fill: "url(#paint2_linear_6102_134469)",
      key: 3,
    }),
    React.createElement("defs", null, [
      React.createElement(
        "linearGradient",
        {
          id: "paint0_linear_6102_134469",
          x1: "6.07512",
          y1: "1.38476",
          x2: "0.738178",
          y2: "17.1514",
          gradientUnits: "userSpaceOnUse",
          key: 4,
        },
        [
          React.createElement("stop", {
            stopColor: "#114A8B",
            key: 5,
          }),
          React.createElement("stop", {
            offset: "1",
            stopColor: "#0669BC",
            key: 6,
          }),
        ]
      ),
      React.createElement(
        "linearGradient",
        {
          id: "paint1_linear_6102_134469",
          x1: "10.3402",
          y1: "11.4564",
          x2: "9.107",
          y2: "11.8734",
          gradientUnits: "userSpaceOnUse",
          key: 7,
        },
        [
          React.createElement("stop", {
            stopOpacity: "0.3",
            key: 8,
          }),
          React.createElement("stop", {
            offset: "0.0711768",
            stopOpacity: "0.2",
            key: 9,
          }),
          React.createElement("stop", {
            offset: "0.321031",
            stopOpacity: "0.1",
            key: 10,
          }),
          React.createElement("stop", {
            offset: "0.623053",
            stopOpacity: "0.05",
            key: 11,
          }),
          React.createElement("stop", {
            offset: "1",
            stopOpacity: "0",
            key: 12,
          }),
        ]
      ),
      React.createElement(
        "linearGradient",
        {
          id: "paint2_linear_6102_134469",
          x1: "9.45858",
          y1: "1.38467",
          x2: "15.3168",
          y2: "16.9926",
          gradientUnits: "userSpaceOnUse",
          key: 13,
        },
        [
          React.createElement("stop", {
            stopColor: "#3CCBF4",
            key: 14,
          }),
          React.createElement("stop", {
            offset: "1",
            stopColor: "#2892DF",
            key: 15,
          }),
        ]
      ),
    ]),
  ],
  "0 0 18 18"
);
